<template>
  <!-- new finder -->
  <div>
    <div v-if="loaded && storeReady" :class="{'finder-container':true, 'mobile-view':isTabletAndSmaller, 'desktop-view':!isTabletAndSmaller}">
      <div class="personalise-search-productlist-container" >
        <div class="member-board-small-screensize" v-if="isTabletAndSmaller" id="member-board-mobile">
            <member-board @selectMemberAtFinder="selectMemberFromBoard" />
          </div>
        <div class="personalise-container">
          <el-form label-position="top">
            <div v-if="!isTabletAndSmaller" class="personalise">
              <div >
                <span class="personalise-title">
                  Personalise
                </span>
                <!-- <el-button type="text" @click="togglePersonaliseCollapsible"> -->
                  <!-- use text collapse and expand with icon-->
                  <!-- <span class="remove-filter" v-if="isPersonaliseCollapsibleOpen">Collapse</span> -->
                  <!-- <span class="remove-filter" v-else>Expand</span> -->
                  <!-- <i class="el-icon-minus" v-if="isPersonaliseCollapsibleOpen"></i> -->
                  <!-- <i class="el-icon-plus" v-else></i> -->
                <!-- </el-button> -->
              </div>
              <el-row :gutter="20" v-if="isPersonaliseCollapsibleOpen" >
                <el-col  :xs="24" :sm="12" :md="8" :lg="8" :xl="8" >
                <el-form-item label="I would like to:">
                  <el-select
                  v-model="personaliseRegoType"
                  :clearable="!isTabletAndSmaller"
                  placeholder="Select"
                  ref="regoType"
                  @change="personaliseSearch"
                  >
                    <el-option
                      v-for="item in regoTypeTiles"
                      :key="item.value"
                      :label="item.title"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                </el-col>
                <el-col v-bind="responsiveCol" >
                <el-form-item label="I am a:">
                  <el-select v-model="personalise.memberType"
                  :clearable="!isTabletAndSmaller"
                  placeholder="Select"
                  ref="membertype"
                    @focus="openDatePicker('membertype')"
                    @change="closeDatePicker('membertype')"
                  >
                    <el-option
                      v-for="item in memberTypeTiles"
                      :key="item.type"
                      :label="item.name"
                      :value="item.type">
                    </el-option>
                  </el-select>
                </el-form-item>
                </el-col>
                <el-col  :xs="12" :sm="12" :md="6" :lg="6" :xl="6" >
                <el-form-item label="Registration Status:">
                  <el-select v-model="personalise.regoOpen"
                    placeholder="Select"
                    ref="rego-open"
                    @focus="openDatePicker('rego-open')"
                    @change="closeDatePicker('rego-open')"
                    >
                    <el-option
                      v-for="regoStatus in regoStatuses"
                      :key="regoStatus.value"
                      :label="regoStatus.label"
                      :value="regoStatus.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                </el-col>
                <el-col class=" mt-20" v-bind="responsiveCol" >
                  <el-button class="register-button" @click="personaliseSearch">Personalise</el-button>
                </el-col>

              </el-row>
            </div>
            <!-- search bar -->
            <div class="search-container">
              <div class="search-box">
                <div class="search-wrapper">
                  <el-input
                    class="search-input"
                    placeholder="Search by keyword"
                    v-model="criteria"
                    @keyup.enter.native="handleSearch">
                  </el-input>
                  <el-button
                    type="primary"
                    class="search-button"
                    @click="handleSearch">
                    <i v-if="isTabletAndSmaller" class="el-icon-search"></i>
                    <span v-else>Search</span>
                  </el-button>
                </div>
              </div>
              <div class="search-checkbox">
                <div>
                  <el-checkbox v-model="isTeamSearch" class="team-name-checkbox"></el-checkbox>
                  <span>
                    Team Name
                  </span>
                </div>
              </div>
            </div>
            <!-- Desktop Filters Section -->
            <div v-if="!isTabletAndSmaller" class="personalise-filters">
              <div class="d-flex justify-content-between ">
                <el-button type="text" @click="toggleFiltersCollapsible">
                  <span v-if="isFiltersCollapsibleOpen" class=""><img :style="{width:'16px'}" src="~@/assets/icons/filter-up.svg"></span>
                  <span v-else class=""><img :style="{width:'16px'}" src="~@/assets/icons/filter-down.svg"></span>
                  <span class="filter-title ml-05">
                    Filters
                    <span v-if="activeFiltersCount > 0" class="filter-count-badge">{{ activeFiltersCount }}</span>
                  </span>
                </el-button>
              </div>
              <div  v-if="isFiltersCollapsibleOpen"  class=" filter-layout mr-0 ml-0 p-10" >
                <el-form-item label="Organization:">
                  <el-select v-model="personalise.organisationId"
                  ref="orgPicker"
                    @focus="openDatePicker('orgPicker')"
                    @change="closeDatePicker('orgPicker')"
                    :clearable="!isTabletAndSmaller"
                   :disabled="fixedOrganisation"
                   placeholder="Select">
                    <el-option-group
                      v-for="group in organisations"
                      :key="group.label"
                      :label="group.label">
                      <el-option
                        v-for="item in group.options"
                        :key="item._id"
                        :label="item.name"
                        :value="item._id">
                      </el-option>
                    </el-option-group>
                  </el-select>
                </el-form-item>
                <el-form-item label="Location">
                  <el-input-number class="input-field postcode"
                   v-model="personalise.location"
                   ref="inputNumber"
                   @focus="changeInputNumber('inputNumber')"
                   :controls="false"
                   type="number"
                    placeholder="Postcode"
                    />
                </el-form-item>
                <!-- date range picker at breakpoint larger than mobile -->
                <div  v-if="!isTabletAndSmaller" class="grid-span-2" >
                <el-form-item label="Event Date">
                  <el-date-picker
                  size="small"
                  class="date-picker"
                    v-model="personalise.eventDateRange"
                    type="daterange"
                    :unlink-panels="false"
                    range-separator="To"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                    value-format="timestamp"
                    :picker-options="pickerOptions"
                    >
                  </el-date-picker>
                </el-form-item>
              </div>
                <el-form-item label="Tags">
                  <el-select v-model="filters.tags"
                    placeholder="Select"
                    :multiple-limit="10"
                    collapse-tags
                    multiple
                    :clearable="!isTabletAndSmaller"
                    ref="tags"
                    @focus="openDatePicker('tags')"
                    @change="closeDatePicker('tags')"
                    >
                    <el-option
                      v-for="item in tags"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Gender">
                  <el-select v-model="filters.gender"
                  placeholder="Select"
                  :clearable="!isTabletAndSmaller"
                  ref="gender"
                    @focus="openDatePicker('gender')"
                    @change="closeDatePicker('gender')"
                  >
                    <el-option
                      v-for="item in genders"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Age From">
                  <el-input-number
                  class="input-field postcode"
                  ref="inputNumber2"
                  @focus="changeInputNumber('inputNumber2')"
                  type="number"
                  :min="1"
                   :max="99"
                   :controls="false"
                   controls-position="right"
                   v-model="filters.ageFrom"/>
                </el-form-item>
                <el-form-item label="Age To">
                  <el-input-number
                  class="input-field postcode"
                  ref="inputNumber3"
                   @focus="changeInputNumber('inputNumber3')"
                   type="number"
                   :min="1"
                   :max="99"
                   :controls="false"
                   controls-position="right"
                   v-model="filters.ageTo"/>
                </el-form-item>
              </div>
              <div  v-if="isFiltersCollapsibleOpen" class="d-flex bg-grey pb-10 pr-10 justify-content-end " >
                <!-- filter button -->
                  <el-button type="primary" class="filter-button" @click="personaliseSearch">Set Filters</el-button>
                  <el-button   type="text" @click="resetFilters">Clear All</el-button>
              </div>
            </div>

            <!-- Mobile Filters Section -->
            <div v-if="isTabletAndSmaller" class="personalise-filters">
              <div class="d-flex justify-content-between align-items-center search-option">
                <el-button type="text" @click="toggleFiltersCollapsible">
                  <span v-if="isFiltersCollapsibleOpen" class=""><img :style="{width:'16px'}" src="~@/assets/icons/filter-up.svg"></span>
                  <span v-else class=""><img :style="{width:'16px'}" src="~@/assets/icons/filter-down.svg"></span>
                  <span class="filter-title ml-05">
                    Search Options
                    <span v-if="activeFiltersCount > 0" class="filter-count-badge">{{ activeFiltersCount }}</span>
                  </span>
                </el-button>
                <el-button v-if="hasActiveFilters" type="text" @click="resetFilters" class="clear-filters-btn">
                  <i class="el-icon-delete"></i> Clear All
                </el-button>
              </div>

              <!-- Desktop Personalise Layout -->
              <el-collapse-transition>
                <div v-if="isPersonaliseCollapsibleOpen && !isTabletAndSmaller" class="filter-layout bg-grey mr-0 ml-0 p-10">
                  <div class="desktop-personalise-grid">
                    <!-- Activity Type -->
                    <el-form-item label="I would like to:">
                      <div class="personalise-buttons">
                        <div
                          v-for="item in regoTypeTiles"
                          :key="item.value"
                          :class="['personalise-button', { 'selected': personaliseRegoType === item.value }]"
                          @click="selectRegoType(item.value)">
                          <span>{{ item.title }}</span>
                        </div>
                      </div>
                    </el-form-item>

                    <!-- Member Type -->
                    <el-form-item label="I am a:">
                      <div class="personalise-buttons">
                        <div
                          v-for="item in memberTypeTiles"
                          :key="item.type"
                          :class="['personalise-button', { 'selected': personalise.memberType === item.type }]"
                          @click="selectMemberType(item.type)">
                          <span>{{ item.name }}</span>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                  <div class="d-flex bg-grey pb-10 pr-10 justify-content-end">
                    <el-button type="primary" class="filter-button" @click="personaliseSearch">Set Personalise</el-button>
                  </div>
                </div>
              </el-collapse-transition>

              <!-- Desktop Filters Layout -->
              <el-collapse-transition>
                <div v-if="isFiltersCollapsibleOpen && !isTabletAndSmaller" class="filter-layout bg-grey mr-0 ml-0 p-10">
                  <div class="desktop-filters-grid">
                    <!-- Organization -->
                    <el-form-item label="Organization:">
                      <el-select v-model="personalise.organisationId"
                        ref="orgPicker"
                        @focus="openDatePicker('orgPicker')"
                        @change="closeDatePicker('orgPicker')"
                        :clearable="true"
                        :disabled="fixedOrganisation"
                        placeholder="Select"
                        :class="{ 'filter-selected': personalise.organisationId }">
                        <el-option-group
                          v-for="group in organisations"
                          :key="group.label"
                          :label="group.label">
                          <el-option
                            v-for="item in group.options"
                            :key="item._id"
                            :label="item.name"
                            :value="item._id">
                          </el-option>
                        </el-option-group>
                      </el-select>
                    </el-form-item>

                    <!-- Registration Status -->
                    <el-form-item label="Registration Status:">
                      <el-select v-model="personalise.regoOpen"
                        placeholder="Select"
                        ref="rego-open"
                        @focus="openDatePicker('rego-open')"
                        @change="closeDatePicker('rego-open')"
                        :clearable="true"
                        :class="{ 'filter-selected': personalise.regoOpen && personalise.regoOpen !== 'open' }">
                        <el-option
                          v-for="regoStatus in regoStatuses"
                          :key="regoStatus.value"
                          :label="regoStatus.label"
                          :value="regoStatus.value">
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <!-- Location -->
                    <el-form-item label="Location">
                      <el-input-number class="input-field postcode"
                        v-model="personalise.location"
                        ref="inputNumber"
                        @focus="changeInputNumber('inputNumber')"
                        :controls="false"
                        type="number"
                        placeholder="Postcode"
                        :class="{ 'filter-selected': personalise.location }" />
                    </el-form-item>

                    <!-- Event Date Range -->
                    <el-form-item label="Event Date" class="date-range-item">
                      <el-date-picker
                        size="small"
                        class="date-picker"
                        v-model="personalise.eventDateRange"
                        type="daterange"
                        :unlink-panels="false"
                        range-separator="To"
                        start-placeholder="Start date"
                        end-placeholder="End date"
                        value-format="timestamp"
                        :picker-options="pickerOptions">
                      </el-date-picker>
                    </el-form-item>

                    <!-- Tags -->
                    <el-form-item label="Tags">
                      <el-select v-model="filters.tags"
                        placeholder="Select"
                        :multiple-limit="10"
                        collapse-tags
                        multiple
                        :clearable="true"
                        ref="tags"
                        @focus="openDatePicker('tags')"
                        @change="closeDatePicker('tags')"
                        :class="{ 'filter-selected': filters.tags && filters.tags.length > 0 }">
                        <el-option
                          v-for="item in tags"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <!-- Gender -->
                    <el-form-item label="Gender">
                      <el-select v-model="filters.gender"
                        placeholder="Select"
                        :clearable="true"
                        ref="gender"
                        @focus="openDatePicker('gender')"
                        @change="closeDatePicker('gender')"
                        :class="{ 'filter-selected': filters.gender }">
                        <el-option
                          v-for="item in genders"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <!-- Age From -->
                    <el-form-item label="Age From">
                      <el-input-number class="input-field age-input"
                        :min="1"
                        :max="99"
                        :controls="false"
                        controls-position="right"
                        v-model="filters.ageFrom"
                        :class="{ 'filter-selected': filters.ageFrom && filters.ageFrom !== 1 }" />
                    </el-form-item>

                    <!-- Age To -->
                    <el-form-item label="Age To">
                      <el-input-number class="input-field age-input"
                        :min="1"
                        :max="99"
                        :controls="false"
                        controls-position="right"
                        v-model="filters.ageTo"
                        :class="{ 'filter-selected': filters.ageTo && filters.ageTo !== 99 }" />
                    </el-form-item>
                  </div>

                  <!-- Set Filters Button -->
                  <div class="d-flex bg-grey pb-10 pr-10 justify-content-end">
                    <el-button type="primary" class="filter-button" @click="personaliseSearch">Set Filters</el-button>
                  </div>
                </div>
              </el-collapse-transition>

              <!-- Mobile Filter Layout with Icons -->
              <el-collapse-transition>
                <div v-if="isFiltersCollapsibleOpen && isTabletAndSmaller" class="mobile-filters-container">
                  <div class="mobile-filters-section">
                  <div class="mobile-filters-grid">

                  <!-- Activity Type Filter (Personalise) -->
                  <div class="mobile-filter-item">
                    <el-popover
                      placement="bottom"
                      width="300"
                      trigger="click"
                      v-model="regoTypePopoverVisible">
                      <div class="mobile-popover-content">
                        <div class="mobile-popover-header">
                          <i class="el-icon-s-flag"></i>
                          <span>Activity Type</span>
                        </div>
                        <div class="mobile-popover-body">
                          <div class="popover-options">
                            <div
                              v-for="item in regoTypeTiles"
                              :key="item.value"
                              :class="['popover-option', { 'selected': personaliseRegoType === item.value }]"
                              @click="selectRegoType(item.value)">
                              <i class="option-check el-icon-check" v-if="personaliseRegoType === item.value"></i>
                              <span>{{ item.title }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="mobile-popover-actions">
                          <el-button size="small" @click="regoTypePopoverVisible = false; personaliseSearch()">Done</el-button>
                        </div>
                      </div>
                      <div slot="reference" :class="['mobile-filter-icon', { 'has-selection': personaliseRegoType }]">
                        <div class="icon-wrapper">
                          <i class="el-icon-s-flag"></i>
                          <div v-if="personaliseRegoType" class="selection-indicator"></div>
                        </div>
                      </div>
                    </el-popover>
                  </div>

                  <!-- Member Type Filter (Personalise) -->
                  <div class="mobile-filter-item">
                    <el-popover
                      placement="bottom"
                      width="300"
                      trigger="click"
                      v-model="memberTypePopoverVisible">
                      <div class="mobile-popover-content">
                        <div class="mobile-popover-header">
                          <i class="el-icon-user-solid"></i>
                          <span>Member Type</span>
                        </div>
                        <div class="mobile-popover-body">
                          <div class="popover-options">
                            <div
                              v-for="item in memberTypeTiles"
                              :key="item.type"
                              :class="['popover-option', { 'selected': personalise.memberType === item.type }]"
                              @click="selectMemberType(item.type)">
                              <i class="option-check el-icon-check" v-if="personalise.memberType === item.type"></i>
                              <span>{{ item.name }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="mobile-popover-actions">
                          <el-button size="small" @click="memberTypePopoverVisible = false; personaliseSearch()">Done</el-button>
                        </div>
                      </div>
                      <div slot="reference" :class="['mobile-filter-icon', { 'has-selection': personalise.memberType }]">
                        <div class="icon-wrapper">
                          <i class="el-icon-user-solid"></i>
                          <div v-if="personalise.memberType" class="selection-indicator"></div>
                        </div>
                      </div>
                    </el-popover>
                  </div>

                  <!-- Organization Filter -->
                  <div class="mobile-filter-item">
                    <el-popover
                        placement="bottom"
                        width="300"
                        trigger="click"
                        v-model="orgPopoverVisible">
                        <div class="mobile-popover-content">
                          <div class="mobile-popover-header">
                            <i class="el-icon-office-building"></i>
                            <span>Organization</span>
                          </div>
                          <div class="mobile-popover-body">
                            <el-select v-model="personalise.organisationId"
                              :disabled="fixedOrganisation"
                              placeholder="Select organization"
                              style="width: 100%">
                              <el-option-group
                                v-for="group in organisations"
                                :key="group.label"
                                :label="group.label">
                                <el-option
                                  v-for="item in group.options"
                                  :key="item._id"
                                  :label="item.name"
                                  :value="item._id">
                                </el-option>
                              </el-option-group>
                            </el-select>
                          </div>
                          <div class="mobile-popover-actions">
                            <el-button size="small" @click="orgPopoverVisible = false; personaliseSearch()">Done</el-button>
                          </div>
                        </div>
                        <div slot="reference" :class="['mobile-filter-icon', { 'has-selection': personalise.organisationId }]">
                          <div class="icon-wrapper">
                            <i class="el-icon-office-building"></i>
                            <div v-if="personalise.organisationId" class="selection-indicator"></div>
                          </div>
                        </div>
                      </el-popover>
                  </div>

                  <!-- Registration Status Filter -->
                  <div class="mobile-filter-item">
                      <el-popover
                        placement="bottom"
                        width="300"
                        trigger="click"
                        v-model="statusPopoverVisible">
                        <div class="mobile-popover-content">
                          <div class="mobile-popover-header">
                            <i class="el-icon-circle-check"></i>
                            <span>Registration Status</span>
                          </div>
                          <div class="mobile-popover-body">
                            <el-select v-model="personalise.regoOpen"
                              placeholder="Select status"
                              style="width: 100%">
                              <el-option
                                v-for="regoStatus in regoStatuses"
                                :key="regoStatus.value"
                                :label="regoStatus.label"
                                :value="regoStatus.value">
                              </el-option>
                            </el-select>
                          </div>
                          <div class="mobile-popover-actions">
                            <el-button size="small" @click="statusPopoverVisible = false; personaliseSearch()">Done</el-button>
                          </div>
                        </div>
                        <div slot="reference" :class="['mobile-filter-icon', { 'has-selection': personalise.regoOpen && personalise.regoOpen !== 'open' }]">
                          <div class="icon-wrapper">
                            <i class="el-icon-circle-check"></i>
                            <div v-if="personalise.regoOpen && personalise.regoOpen !== 'open'" class="selection-indicator"></div>
                          </div>
                        </div>
                      </el-popover>
                  </div>

                  <!-- Location Filter -->
                  <div class="mobile-filter-item">
                      <el-popover
                        placement="bottom"
                        width="300"
                        trigger="click"
                        v-model="locationPopoverVisible">
                        <div class="mobile-popover-content">
                          <div class="mobile-popover-header">
                            <i class="el-icon-location"></i>
                            <span>Location</span>
                          </div>
                          <div class="mobile-popover-body">
                            <el-input-number
                            v-model="personalise.location"
                            :controls="false"
                            type="tel"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            placeholder="Enter postcode"
                            style="width: 100%" />
                        </div>
                        <div class="mobile-popover-actions">
                          <el-button size="small" @click="locationPopoverVisible = false; personaliseSearch()">Done</el-button>
                        </div>
                      </div>
                      <div slot="reference" :class="['mobile-filter-icon', { 'has-selection': personalise.location }]">
                        <div class="icon-wrapper">
                          <i class="el-icon-location"></i>
                          <div v-if="personalise.location" class="selection-indicator"></div>
                        </div>
                      </div>
                      </el-popover>
                  </div>

                  <!-- Date Filter -->
                  <div class="mobile-filter-item">
                      <el-popover
                      placement="bottom"
                      width="350"
                      trigger="click"
                      v-model="datePopoverVisible">
                      <div class="mobile-popover-content">
                        <div class="mobile-popover-header">
                          <i class="el-icon-date"></i>
                          <span>Event Date</span>
                        </div>
                        <div class="mobile-popover-body">
                          <div class="date-inputs">
                            <el-date-picker
                              v-model="personalise.eventDateRange[0]"
                              placeholder="Start date"
                              value-format="timestamp"
                              style="width: 100%; margin-bottom: 12px" />
                            <el-date-picker
                              v-model="personalise.eventDateRange[1]"
                              placeholder="End date"
                              value-format="timestamp"
                              style="width: 100%" />
                          </div>
                        </div>
                        <div class="mobile-popover-actions">
                          <el-button size="small" @click="datePopoverVisible = false; personaliseSearch()">Done</el-button>
                        </div>
                      </div>
                      <div slot="reference" :class="['mobile-filter-icon', { 'has-selection': personalise.eventDateRange && personalise.eventDateRange.some(date => date) }]">
                        <div class="icon-wrapper">
                          <i class="el-icon-date"></i>
                          <div v-if="personalise.eventDateRange && personalise.eventDateRange.some(date => date)" class="selection-indicator"></div>
                        </div>
                      </div>
                      </el-popover>
                  </div>

                  <!-- Tags Filter -->
                  <div class="mobile-filter-item">
                      <el-popover
                        placement="bottom"
                        width="300"
                        trigger="click"
                        v-model="tagsPopoverVisible">
                      <div class="mobile-popover-content">
                        <div class="mobile-popover-header">
                          <i class="el-icon-collection-tag"></i>
                          <span>Tags</span>
                        </div>
                        <div class="mobile-popover-body">
                          <el-select v-model="filters.tags"
                            placeholder="Select tags"
                            :multiple-limit="10"
                            collapse-tags
                            multiple
                            style="width: 100%">
                            <el-option
                              v-for="item in tags"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </div>
                        <div class="mobile-popover-actions">
                          <el-button size="small" @click="tagsPopoverVisible = false; personaliseSearch()">Done</el-button>
                        </div>
                      </div>
                      <div slot="reference" :class="['mobile-filter-icon', { 'has-selection': filters.tags && filters.tags.length > 0 }]">
                        <div class="icon-wrapper">
                          <i class="el-icon-collection-tag"></i>
                          <div v-if="filters.tags && filters.tags.length > 0" class="selection-indicator"></div>
                        </div>
                      </div>
                      </el-popover>
                  </div>

                  <!-- Gender Filter -->
                  <div class="mobile-filter-item">
                      <el-popover
                        placement="bottom"
                        width="300"
                        trigger="click"
                        v-model="genderPopoverVisible">
                      <div class="mobile-popover-content">
                        <div class="mobile-popover-header">
                          <i class="el-icon-user"></i>
                          <span>Gender</span>
                        </div>
                        <div class="mobile-popover-body">
                          <el-select v-model="filters.gender"
                            placeholder="Select gender"
                            style="width: 100%">
                            <el-option
                              v-for="item in genders"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </div>
                        <div class="mobile-popover-actions">
                          <el-button size="small" @click="genderPopoverVisible = false; personaliseSearch()">Done</el-button>
                        </div>
                      </div>
                      <div slot="reference" :class="['mobile-filter-icon', { 'has-selection': filters.gender }]">
                        <div class="icon-wrapper">
                          <i class="el-icon-user"></i>
                          <div v-if="filters.gender" class="selection-indicator"></div>
                        </div>
                      </div>
                      </el-popover>
                  </div>

                  <!-- Age Range Filter -->
                  <div class="mobile-filter-item">
                      <el-popover
                        placement="bottom"
                        width="300"
                        trigger="click"
                        v-model="agePopoverVisible">
                      <div class="mobile-popover-content">
                        <div class="mobile-popover-header">
                          <i class="el-icon-timer"></i>
                          <span>Age Range</span>
                        </div>
                        <div class="mobile-popover-body">
                          <div class="age-inputs">
                            <el-input-number
                              v-model="filters.ageFrom"
                              :min="1"
                              :max="99"
                              :controls="false"
                              placeholder="From"
                              style="width: 48%; margin-right: 4%" />
                            <el-input-number
                              v-model="filters.ageTo"
                              :min="1"
                              :max="99"
                              :controls="false"
                              placeholder="To"
                              style="width: 48%" />
                          </div>
                        </div>
                        <div class="mobile-popover-actions">
                          <el-button size="small" @click="agePopoverVisible = false; personaliseSearch()">Done</el-button>
                        </div>
                      </div>
                      <div slot="reference" :class="['mobile-filter-icon', { 'has-selection': (filters.ageFrom && filters.ageFrom !== 1) || (filters.ageTo && filters.ageTo !== 99) }]">
                        <div class="icon-wrapper">
                          <i class="el-icon-timer"></i>
                          <div v-if="(filters.ageFrom && filters.ageFrom !== 1) || (filters.ageTo && filters.ageTo !== 99)" class="selection-indicator"></div>
                        </div>
                      </div>
                      </el-popover>
                  </div>
                </div>
                </div>
                </div>
              </el-collapse-transition>
            </div>
            <div class="d-flex gap-3 align-items-end">
              <!-- <el-button class="register-button" @click="personaliseSearch">Personalise</el-button> -->
            </div>
          </el-form>
        </div>
        <div class="px-10 pt-10 " v-if="searchingRequiredMs">
          <el-tag closable @close="handleTagClose()">
            Memberships required
          </el-tag>
        </div>
        <!-- Upgrade Filter Toggle -->

        <div class="products-members-container" v-if="member">
          <ul class="registration-event-container"  :key="key"   >
              <li v-for="(registration,index) in formattedRegistrationArray"    :class="{fullwidth: registration.type === 'addon', 'infinite-list-item':true}" :key="index">
                <div :ref="registration.type === 'main' ? `registration-main-${index}` : ''">
                  <registration-card   :registration="registration"  @event-register-clicked="handleEventClicked" v-if="registration.type==='main'" :key="key" @inOpenBulkRego="handleOpenBulkRego" :privateProps="privateProps" :selectedMember="member" :members="memberList" :teamId="filters.teamId" @searchByTag="searchByTag" :memberMembership="memberMembership" :checkUpgradeEligible="checkUpgradeEligible" :checkProductUpgradeEligible="checkProductUpgradeEligible" @upgrade-click="openUpgradeDialog"/>
                  <registration-card :registration="registration"   v-if="registration.type==='addon'" @joinWaitList="joinWaitList" @register="startRegistration" @inOpenBulkRego="handleOpenBulkRego" :key="key" :privateProps="privateProps" :selectedMember="member" :members="memberList" :teamId="filters.teamId" @searchByTag="searchByTag" :memberMembership="memberMembership" :checkUpgradeEligible="checkUpgradeEligible" :checkProductUpgradeEligible="checkProductUpgradeEligible" @upgrade-click="openUpgradeDialog" />
                </div>
              </li>
          </ul>
        </div>
        <p class="d-flex justify-content-center fs-13 fw-bold " v-if="loading">Loading more events...</p>
        <p class="d-flex justify-content-center fs-13 fw-bold " v-if="!loading && isNoMore">Adjust the Filters and Personalisation settings or Search to find more registration options</p>
      </div>

      <!-- <p class="d-flex justify-content-center fs-13 fw-bold " v-if="noMore">No more events </p> -->

          <div class="team-members-board mx-10 mt-15" v-if="!isTabletAndSmaller">
            <member-board :atFinder="true" @selectMemberAtFinder="selectMemberFromBoard"/>
          </div>
    </div>
    <el-dialog
      :title="getTitle"
      :visible.sync="clearanceDialogVisible"
      width="30%"
      >
      <div class="d-flex flex-column " v-if="!memberClearanceRequest">
        <span class="break-word">You are already registered to another club as a player, you need to request a clearance to be able to continue.</span>
        <div class="mt-10">
          <el-input-title >Reason</el-input-title>
          <el-input class="search-box input-field reason" placeholder="Type your reason here" v-model="clearanceRequest.reason" ></el-input>
        </div>
      </div>
      <div class="d-flex flex-column " v-if="memberClearanceRequest && memberClearanceRequest.status ==='Pending'">
        <span class="break-word">Registration clearance has been submmited. Please contact your Club or Association for further information.</span>
      </div>
      <div class="d-flex flex-column w-100" v-if="memberClearanceRequest && memberClearanceRequest.status ==='Declined'">
      <span class="break-word">Registration clearance has been denied. Please contact your Club or  Association for further information.</span>
      <span class="break-word">If you would like to request another clearance, please click Request another clearance button below.</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearanceDialogVisible = false , clearanceRequest.reason= '' ">Cancel</el-button>
        <el-button type="primary" v-if="!memberClearanceRequest " @click="handleRequestClearances">Request Clearance</el-button>
        <el-button type="primary" v-if="memberClearanceRequest && memberClearanceRequest.status ==='Declined'" @click="handleRequestClearances">Request Another Clearance</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="requireMembershipDialog"
      title="Membership Required"
      :visible.sync="requireMembershipDialog"
      width="50%"
      >
      <div class="break-word">To register for  {{selectedRego.name | cap}}, Select from the list as participants must first have one of the following:</div>
      <!-- take form selectedRego.products[0].membershipProductsRequired -->
      <div class="product-required-list">
          <div class="product-required" v-for="membership in selectedRego.products[0].membershipProductsRequired" :key="membership._id">
            <el-tag class="membership-type" >
              {{get(membership,'products.memberType', '') | cap}}
              <!-- Match Official -->
            </el-tag>
            <!-- <div class="membership-type"></div> -->
            <div class="break-word membership-name">{{membership.name}}</div>
            <div >
              <el-button class="register-button"  type="primary" size="medium" @click="selectMembership(membership)">Select</el-button>
            </div>
      </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="requireMembershipDialog = false">Cancel</el-button>
      </span>
    </el-dialog>
    <!-- accreditation -->
    <el-dialog
      v-if="requireAccreditationDialog"
      title="Accreditation Required"
      :visible.sync="requireAccreditationDialog"
      width="50%"
    >
      <div class="break-word">To register for {{selectedRego.name | cap}}, you must first apply for one of the following accreditations:</div>
      <div class="accreditation-required-list">
        <div class="accreditation-required" v-for="accreditation in selectedRego.products[0].accreditationProductsRequired" :key="accreditation._id">
          <el-tag class="accreditation-type">
            {{accreditation.name}}
          </el-tag>
          <div class="break-word accreditation-name"></div>
          <div>
            <el-button class="apply-button" type="primary" size="medium" @click="applyForAccreditation(accreditation)">Apply</el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="requireAccreditationDialog = false">Cancel</el-button>
      </span>
    </el-dialog>
    <el-dialog
  v-if="requireAccreditationAdditionalFields"
  title="Additional Information Required"
  :visible.sync="requireAccreditationAdditionalFields"
  width="50%"
  custom-class="accreditation-dialog"
>
  <div class="dialog-content">
    <div class="dialog-description break-word">
      Please provide the following information to complete your accreditation application:
    </div>

    <el-form ref="additionalFieldsForm" :model="additionalFieldsData">
      <!-- Text fields -->
       <div v-if="selectedAccreditation?.additionalFields?.length">
      <el-form-item
    v-for="field in selectedAccreditation?.additionalFields?.filter(f => f.type === 'text')"
    :key="field.label"
    :class="'form-item'"
  >
    <div class="field-label">{{ field.label }}</div>
    <el-input
      v-model="additionalFieldsData[field.label]"
      placeholder="Enter text"
      class="custom-input"
    />
  </el-form-item>

  <!-- Date fields -->
  <el-form-item
    v-for="field in selectedAccreditation.additionalFields.filter(f => f.type === 'date')"
    :key="field.label"
    :class="'form-item'"
  >
    <div class="field-label">{{ field.label }}</div>
    <el-date-picker
      v-model="additionalFieldsData[field.label]"
      type="date"
      placeholder="Select date"
      class="custom-input w-100"
    />
  </el-form-item>
  <el-form-item
  v-for="field in selectedAccreditation.additionalFields.filter(f => f.type === 'boolean')"
  :key="field.label"
  :class="'form-item'"
>
  <div class="field-label">{{ field.label }}</div>
  <el-switch
    v-model="additionalFieldsData[field.label]"
    active-color="#002B5C"
    inactive-color="#DCDFE6"
  />
</el-form-item>

<!-- Number type -->
<el-form-item
  v-for="field in selectedAccreditation.additionalFields.filter(f => f.type === 'number')"
  :key="field.label"
  :class="'form-item'"
>
  <div class="field-label">{{ field.label }}</div>
  <el-input-number
    v-model="additionalFieldsData[field.label]"
    :controls="true"
    :min="0"
    class="custom-input w-100"
    placeholder="Enter number"
  />
</el-form-item>

</div>

      <!-- File upload -->
      <div v-if="selectedAccreditation.fileUploadRequired" class="upload-section">
  <div class="upload-info">
    <p class="upload-text">
      {{ selectedAccreditation.uploadText }}
      <el-tooltip
        class="upload-tooltip"
        effect="light"
        placement="right">
        <div slot="content" class="tooltip-content">
          You can upload your required file now or later through:
          <br>
          <span class="upload-path">Portal → Member → Accreditations → Operations</span>
        </div>
        <i class="el-icon-info"></i>
      </el-tooltip>
    </p>
  </div>

  <el-upload
    drag
    action="#"
    :headers="uploadHeaders"
    :accept="fileUploadAccepts"
    :file-list="fileList"
    :auto-upload="false"
    :on-change="handleFileChange"
    :before-upload="beforeFileUpload"
  >
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
    <span class="fs-11px"><i class="el-icon-info"></i> Files must be 10mb or less</span>
  </el-upload>
</div>
    </el-form>
  </div>

  <span slot="footer" class="dialog-footer">
    <el-button class="cancel-button" @click="requireAccreditationAdditionalFields = false">Cancel</el-button>
    <el-button type="primary" class="submit-button" @click="submitAccreditationApplication">Apply</el-button>
  </span>
</el-dialog>
 <!-- Mobile Event Drawer -->
 <el-drawer
      :visible.sync="mobileDrawerVisible"
      direction="btt"
      size="90%"
      :modal="true"
      :show-close="false"
      custom-class="mobile-event-drawer"
      @close="closeDrawer">

      <!-- Drawer Header with Event Info -->
      <div class="drawer-header" slot="title">
        <div class="drawer-event-info">
          <div class="drawer-avatar">
            <el-avatar size="small">
              <img :src="getRegoLogo(expandedRegistration)" />
            </el-avatar>
          </div>
          <div class="drawer-details">
            <div class="drawer-title">{{ expandedRegistration?.name || 'Event Registration' }}</div>
            <div class="drawer-subtitle">{{ expandedRegistration?.orgtree?.[expandedRegistration?.entityType]?.name || '' }}</div>
          </div>
        </div>
        <div class="drawer-actions">
          <!-- <el-button size="mini" type="text" @click="toggleExpandAll" class="expand-collapse-btn">
            <span v-if="!drawerExpandAll">Expand All</span>
            <span v-else>Collapse All</span>
          </el-button> -->
          <el-button size="mini" type="text" @click="closeDrawer">
            <i class="el-icon-close"></i>
          </el-button>
        </div>
      </div>

      <!-- Drawer Content -->
      <div class="drawer-content" v-if="expandedRegistration">
        <!-- Product List -->
        <div class="drawer-products">
          <registration-card
            :registration="{ ...expandedRegistration, type: 'addon' }"
            @joinWaitList="joinWaitList"
            @register="startRegistration"
            @inOpenBulkRego="handleOpenBulkRego"
            :key="`drawer-addon-${key}`"
            :privateProps="privateProps"
            :selectedMember="member"
            :members="memberList"
            :teamId="filters.teamId"
            @searchByTag="searchByTag" />
        </div>
      </div>
    </el-drawer>

    <!-- Search Tour -->
    <SearchTour
      :is-active="showSearchTour"
      @tour-completed="handleSearchTourCompleted"
      @tour-skipped="handleSearchTourSkipped"
      @tour-closed="handleSearchTourClosed"
    />

    <!-- Tour trigger button for returning users -->
    <div v-if="hasVisitedSearchBefore" class="search-tour-trigger">
      <el-button
        type="text"
        @click="restartSearchTour"
        class="restart-tour-button"
      >
        <i class="el-icon-question"></i>
        Help
      </el-button>
    </div>

<!-- Upgrade Dialog -->
<el-dialog
  v-if="upgradeDialogVisible"
  title="Membership Upgrade Options"
  :visible.sync="upgradeDialogVisible"
  width="60%"
  custom-class="upgrade-dialog"
  @close="closeUpgradeDialog"
>
  <div class="upgrade-dialog-content">
    <div class="upgrade-header">
      <div class="target-membership">
        <h3>Upgrade to: {{ selectedUpgradeRego?.name }}</h3>
        <p class="target-description">
          {{ selectedUpgradeProduct ? selectedUpgradeProduct.name : selectedUpgradeRego?.product[0]?.name }}
        </p>
        <div class="target-price">
          <span class="price-label">Price: </span>
          <span class="price-value">
            ${{ ((selectedUpgradeProduct ? selectedUpgradeProduct.price : selectedUpgradeRego?.product[0]?.price || 0) / 100).toFixed(2) }}
          </span>
        </div>
      </div>
    </div>

    <div class="upgrade-options" v-if="upgradeableFromMemberships.length > 0">
      <h4>Select a membership to upgrade from:</h4>
      <div class="membership-options">
        <div
          v-for="option in upgradeableFromMemberships"
          :key="option.membership._id"
          class="membership-option"
          :class="{ 'selected': selectedSourceMembership === option }"
          @click="selectedSourceMembership = option"
        >
          <div class="membership-info">
            <div class="membership-name">{{ formatMembershipName(option.membership) }}</div>
            <div class="membership-details">
              <span class="expiry">Expires: {{ new Date(option.membership.expiry).toLocaleDateString() }}</span>
            </div>
          </div>
          <div class="upgrade-benefit">
            <div class="savings" v-if="calculateUpgradeSavings(option.membership, selectedUpgradeProduct || selectedUpgradeRego?.product[0])">
              <i class="el-icon-money"></i>
              Save {{ calculateUpgradeSavings(option.membership, selectedUpgradeProduct || selectedUpgradeRego?.product[0]) }}
            </div>
            <div class="upgrade-icon">
              <i class="el-icon-top-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="no-upgrade-options">
      <p>No eligible memberships found for upgrade.</p>
    </div>
  </div>

  <span slot="footer" class="dialog-footer">
    <el-button @click="closeUpgradeDialog">Cancel</el-button>
    <el-button
      type="primary"
      @click="processUpgrade"
      :loading="upgradeProcessing"
      :disabled="!selectedSourceMembership"
    >
      {{ upgradeProcessing ? 'Processing...' : 'Proceed with Upgrade' }}
    </el-button>
  </span>
</el-dialog>
    <el-dialog
      :visible.sync="teamSearchConfirmDialogVisible"
      title="Search for a Team"
      width="400px"
      :close-on-click-modal="false"
    >
      <span>Are you searching for a team?</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="teamSearchConfirm('cancel')">Cancel</el-button>
          <el-button type="warning" @click="teamSearchConfirm('no')">No</el-button>
          <el-button type="primary" @click="teamSearchConfirm('yes')">Yes</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      :visible.sync="searchedTeamsDialogVisible"
      title="Available Teams"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-table
        :data="searchedTeams"
        max-height="400"
        @row-click="handleSearchedTeamSelected($event)"
      >
        <!-- ID Column -->
        <el-table-column min-width="80" property="name" label="ID">
          <template #default="scope">
            <span>{{ scope.row._id }}</span>
          </template>
        </el-table-column>

        <!-- Team Name Column -->
        <el-table-column min-width="220" property="date" label="Team Name">
          <template #default="scope">
            <span class="break-word">{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <!-- Contact Name Column -->
        <el-table-column min-width="150" label="Contact Name">
          <template #default="scope">
            <div style="display: flex; align-items: flex-start;">
              <span class="break-word">{{ scope.row.contact.name }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- Footer buttons -->
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeSearchTeamsDialog">Close</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- <div v-if="loading">

      <p>Loading...</p>

      </div> -->
  </div>
</template>

<script>
import { calculateMemberAge } from '@/utils/helpers';
import smoothscroll from 'smoothscroll-polyfill';
import moment from 'moment';

// import InfiniteLoading from 'vue-infinite-loading';
import {
  regoTypeTiles, genders, fileUploadAccepts
} from '@/utils/constants';
import _ from 'lodash';
import { datadogRum } from '@datadog/browser-rum';
import memberBoard from '../../components/members/NewMemberBoard.vue';
import registrationCard from './components/registration-card.vue';
import SearchTour from '../../components/onboarding/SearchTour.vue';

// const fetchWeather = (registrations) => {
//   // eslint-disable-next-line no-restricted-syntax
//   for (const rego of registrations) {
//     if (_.get(rego, 'weather.weatherCode')) {
//       rego.weather.base = _.find(weatherCodes, (c) => c.value === _.get(rego, 'weather.weatherCode')) || {};
//     }
//   }
//   return registrations;
// };
// const doSearchByMembership = (self, criteria, filters = {}) => {
//   self.$store.commit('loading', { loading: true, text: 'Loading...' });
//   const { entityId } = self;
//   if (entityId) { _.assign(filters, { eventId: entityId }); }
//   self.$http.post('/assemble/api/v1/portal/registrations/search/memberships', {
//     criteria,
//     filters
//   }).then(async (res) => {
//     const { result, transactionFee } = res.data.data;
//     // eslint-disable-next-line no-param-reassign
//     self.registrations = fetchWeather(result);
//     self.$store.commit('cart/setTransactionFee', transactionFee);
//     self.$store.commit('loading', false);
//   }).catch((e) => {
//     self.$message.error(e.response.data.message);
//     self.$store.commit('loading', false);
//   });
// };

export default {
  components: {
    registrationCard,
    memberBoard,
    SearchTour,
    // InfiniteLoading,
  },
  props: {
    productId: String,
    entityId: String,
    id: String,
    password: String,
  },
  data() {
    return {
      personaliseRegoType: undefined,
      fileList: [],
      uploadedFile: null,
      fileUploadAccepts,
      isUploading: false,
      loading: false,
      isNoMore: false,
      genders,
      selectedMember: undefined,
      oldRegoId: undefined,
      isPersonaliseCollapsibleOpen: true,
      isFiltersCollapsibleOpen: this.$store.getters['finder/isFiltersCollapsibleOpen'],
      clearanceDialogVisible: false,
      clearanceDeclinedDialogVisible: false,
      memberClearanceRequest: undefined,
      clearanceRequest: {
        reason: undefined,
      },
      criteria: '',
      teamKeyword: '',
      defaultRegoLogo: process.env.VUE_APP_LOGO,
      allTeams: [],
      innerWidth: window.innerWidth,
      requireMembershipDialog: false,
      requireAccreditationDialog: false,
      requireAccreditationAdditionalFields: false,
      selectedRego: undefined,
      selectedAccreditation: null,
      additionalFieldsData: {},
      memberId: undefined,
      regoTypeTiles,
      busy: false, // infinite scroll
      memberTypeTiles: [],
      registrations: [], // all registrations
      pageNumber: 1,
      pageSize: 10,
      personalise: {
        regoType: undefined,
        memberType: undefined,
        memberId: undefined,
        location: undefined,
        eventDateRange: undefined,
        tags: [],
        organisationId: undefined,
        regoOpen: 'open',
      },
      filters: {
        registrationTypes: undefined,
        memberTypes: undefined,
        memberId: undefined,
        tags: [],
        entityType: undefined,
        location: undefined,
        eventDateRange: [],
        organisation: {
          _id: undefined,
          level: undefined,
        },
        productId: undefined,
        regoOpen: 'open',
        gender: undefined,
        ageFrom: 1,
        ageTo: 99

      },
      regoStatuses: [
        {
          label: 'Open',
          value: 'open',
        },
        {
          label: 'Closed',
          value: 'closed',
        },
      ],
      tags: [],
      memberTypes: [],
      memberList: [],
      organisations: [
        {
          label: 'State',
          options: [],
        },
        {
          label: 'Association',
          options: [],
        },
        {
          label: 'Club',
          options: [],
        },
      ],  // eslint-disable-line

      // Search tour properties
      showSearchTour: false,

      // Pending drawer open for entity/product from route params
      pendingEntityOpen: null,
      viewingRego: null,
      key: 0,
      // Upgrade dialog data
      upgradeDialogVisible: false,
      selectedUpgradeRego: null,
      selectedUpgradeProduct: null,
      upgradeableFromMemberships: [],
      selectedSourceMembership: null,
      upgradeProcessing: false,
      loaded: false,
      total: 0,
      mobileDrawerVisible: false,
      expandedRegistration: null,
      pickerOptions: {
        shortcuts: [{
          text: 'In 1 week',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'In 1 month',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'In 3 months',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }, // infinite scroll
      member: undefined,
      memberMembership: undefined,
      get: _.get,
      fixedOrganisation: false,
      searchingRequiredMs: false,
      notFetching: false,
      storeReady: false,
      membershipRequiredProductsList: [],
      teamSearchConfirmDialogVisible: false,
      searchedTeamsDialogVisible: false,
      searchedTeams: [],
      selectedTeam: null,
      isTeamSearch: false,
      // Mobile popover visibility states
      regoTypePopoverVisible: false,
      memberTypePopoverVisible: false,
      orgPopoverVisible: false,
      statusPopoverVisible: false,
      locationPopoverVisible: false,
      datePopoverVisible: false,
      tagsPopoverVisible: false,
      genderPopoverVisible: false,
      agePopoverVisible: false,
    };
  },
  async mounted() {
    // Scroll to top on mobile devices
    this.$nextTick(() => {
      window.scrollTo({ top: 0, behavior: 'instant' });
    });

    this.isNoMore = false;
    // if (this.entityId) { this.$store.commit('finder/clearFitlers'); }
    // Apply the polyfill
    smoothscroll.polyfill();
    // event listener for resizing
    window.addEventListener('resize', this.handleResize);

    window.addEventListener('scroll', this.debounce(this.handleScroll, 200));
    const storedFillters = this.$store.getters['finder/getFilters'];
    const storedPersonalise = this.$store.getters['finder/getPersonalise'];
    const storedCriteria = this.$store.getters['finder/getCriteria'];
    if (storedFillters) {
      this.filters = _.assign(this.filters, storedFillters);
    }
    if (storedPersonalise) {
      if (storedPersonalise.eventDateRange) {
        storedPersonalise.eventDateRange = storedPersonalise.eventDateRange.map((d) => (d || undefined));
      }
      this.personaliseRegoType = storedPersonalise.regoType;
      this.personalise = _.assign(this.personalise, storedPersonalise);
    }
    if (storedCriteria) {
      this.criteria = storedCriteria;
    }

    const maxAttempts = 10;
    let attempts = 0;

    while (!this.$store.getters['national/getOrganisation']?._id && attempts < maxAttempts) {
      // eslint-disable-next-line no-await-in-loop
      await new Promise((resolve) => setTimeout(resolve, 100)); // Wait 100ms between checks
      attempts++;
    }

    const storedOrganisation = this.$store.getters['national/getOrganisation'];
    if (storedOrganisation?._id) {
      this.filters.organisation._id = storedOrganisation._id;
      this.filters.organisation.level = _.capitalize(storedOrganisation.level);
      this.personalise.organisationId = storedOrganisation._id;
      if (this.filters.organisation.level !== 'national') {
        this.fixedOrganisation = true;
      }
    } else {
      this.filters.organisation._id = undefined;
      this.filters.organisation.level = undefined;
      this.personalise.organisationId = undefined;
    }

    const {
      pendingRegistration, membershipRequiredProducts
    } = this.$route.params;
    const { entityId, member } = this;

    // if any params are present, set the isFiltersCollapsibleOpens to false
    if (this.id || this.entityId || this.productId || this.password) {
      this.isFiltersCollapsibleOpen = false;
      // If there's an entityId, store it to open drawer after registrations are loaded
      if (this.entityId || this.id) {
        const id = parseInt(this.entityId, 10) || parseInt(this.id, 10);
        this.pendingEntityOpen = id;
      }
    }
    if (this.entityId && this.productId) {
      this.criteria = this.entityId;
      this.filters.productId = this.productId;
      // If there's an entityId, automatically open the addon section
    } else {
      this.filters.productId = undefined;
    }
    if (entityId) { _.assign(this.filters, { eventId: entityId }); } else {
      this.filters.eventId = undefined;
    }
    if (this.id && this.entityId) {
      this.filters.teamId = this.id;
    }
    if (this.id && !this.entityId) {
      this.criteria = this.id;
    }
    if (pendingRegistration) {
      this.criteria = pendingRegistration;
      await this.search();
    }

    // commit loading and loading text
    this.$store.commit('loading', { loading: true, text: 'Loading events...' });
    // this.$store.commit('loadingText', 'Loading events...');
    await this.getMemberTypes();
    await this.getMemberList();
    await this.getOrganisations();
    await this.getTagGroups();
    const endOfYear = this.$store.getters['national/endOfYear'];

    if (this.memberId) {
      _.assign(this.filters, { memberId: this.memberId });
    }
    if (membershipRequiredProducts && membershipRequiredProducts.length > 0) {
      this.$set(this, 'membershipRequiredProductsList', membershipRequiredProducts);
      this.searchingRequiredMs = true;
      this.criteria = '';
    }
    if (member && member.profile.dob) { _.assign(this.filters, { age: calculateMemberAge(member.profile.dob, endOfYear) }); }
    if (member && member.profile.gender) { _.assign(this.filters, { gender: member.profile.gender }); }
    this.$http.post(`/assemble/api/v1/portal/registrations/new-search/${this.pageSize}/${this.pageNumber}`, {
      criteria: _.trim(this.criteria),
      filters: this.filters,
      membershipProductsRequired: membershipRequiredProducts && membershipRequiredProducts.length > 0 ? membershipRequiredProducts : []
    }).then(async (res) => {
      const { result, transactionFee, total } = res.data.data;
      this.totalData = total;
      // eslint-disable-next-line no-param-reassign
      this.registrations = result;
      this.loaded = true;
      // eslint-disable-next-line no-param-reassign
      this.$store.commit('cart/setTransactionFee', transactionFee);
      this.$store.commit('loading', false);

      // Handle pending entity open after registrations are loaded
      if (this.pendingEntityOpen) {
        this.$nextTick(() => {
          this.handleEventClicked(this.pendingEntityOpen);
          this.pendingEntityOpen = null; // Clear after handling
        });
      }
    }).catch((e) => {
      this.$message.error(e.response.data.message);
      this.$store.commit('loading', false);
    });
    this.teamDetails = {};

    if (this.memberId) {
      // this.memberId = this.personalise.memberId;
      this.$store.commit('loading', { loading: true, text: 'Loading member...' });
      // this.$store.commit('loadingText', 'Loading member...');
      Promise.all([
        this.getMemberMembership(this.memberId),
        this.$http.get(`/assemble/api/v1/account/portal/members/${this.memberId}`),
      ])
        .then(([resMemberMembership, resMember]) => {
          this.member = resMember.data.data;
          this.memberMembership = resMemberMembership.data.data;
          this.$store.commit('user/setMemberRegos', this.memberMembership);
          this.$store.commit('loading', false);
        }).catch((error) => {
          this.$message.error(error.response.data.message);
          this.$store.commit('loading', false);
        });
    }

    this.storeReady = true;

    // Auto-start search tour for first-time visitors
    this.$nextTick(() => {
      if (!this.hasVisitedSearchBefore) {
        setTimeout(() => {
          this.startSearchTour();
        }, 1500); // Small delay to let the page settle
      }
    });
  },
  updated() {
    this.$nextTick(() => {
      const inputElement = this.$refs.inputNumber?.$el?.querySelector('input');
      const inputElement2 = this.$refs.inputNumber2?.$el?.querySelector('input');
      const inputElement3 = this.$refs.inputNumber3?.$el?.querySelector('input');
      if (inputElement) {
        inputElement.type = 'tel';
      }
      if (inputElement2) {
        inputElement2.type = 'tel';
      }
      if (inputElement3) {
        inputElement3.type = 'tel';
      }
    });
  },
  computed: {
    hasCustomEntity() {
      const customEntity = this.$store.getters['national/getEntity'];
      if (customEntity && customEntity.level && customEntity.name) {
        return true;
      }
      return false;
    },
    cartCount() {
      return this.$store.getters['cart/counts'];
    },
    privateProps() {
      return {
        productId: this.productId,
        entityId: this.entityId,
        password: this.password,
        regoType: _.get(this.personalise, 'regoType'),
      };
    },
    currentMemberMemberships() {
      return this.$store.getters['user/getActiveMemberRegos'] || [];
    },
    isTabletAndSmaller() {
      return this.innerWidth <= 769;
    },
    isBigTabletAndSmaller() {
      return this.innerWidth <= 1200;
    },
    noMore() {
      return this.registrations.length >= this.totalData;
    },
    responsiveCol() {
      return {
        xs: 12,
        sm: 12,
        md: 6,
        lg: 5,
        xl: 5,
      };
    },
    getTitle() {
      return this.memberClearanceRequest
        ? 'Registration unavailable'
        : 'Registration Clearance Request';
    },
    formattedRegistrationArray() {
      const { viewingRego } = this;
      let filteredRegistrations = this.registrations;

      // Apply upgrade filter if enabled
      if (this.showUpgradeableOnly) {
        filteredRegistrations = this.registrations.filter((reg) => this.checkUpgradeEligible(reg));
      }

      return filteredRegistrations.reduce((acc, curr) => {
        if ((curr.products.length >= 1) && curr._id === viewingRego) {
          return acc.concat([
            {
              ...curr,
              type: 'main',
              showIndicators: true,
            },
            {
              ...curr,
              type: 'addon',
            }
          ]);
        }
        return acc.concat([{
          ...curr,
          type: 'main',
        }]);
      }, []);
    },
    activeFiltersCount() {
      let count = 0;
      if (this.personalise.organisationId) count++;
      if (this.personalise.location) count++;
      if (this.personalise.regoOpen && this.personalise.regoOpen !== 'open') count++;
      if (this.personalise.eventDateRange && this.personalise.eventDateRange.some((date) => date)) count++;
      if (this.filters.tags && this.filters.tags.length > 0) count++;
      if (this.filters.gender) count++;
      if (this.filters.ageFrom && this.filters.ageFrom !== 1) count++;
      if (this.filters.ageTo && this.filters.ageTo !== 99) count++;
      if (this.personaliseRegoType) count++;
      if (this.personalise.memberType) count++;
      return count;
    },
    hasActiveFilters() {
      return this.activeFiltersCount > 0;
    },

    // Search tour computed properties
    hasVisitedSearchBefore() {
      return localStorage.getItem('search_tour_completed') === 'true';
    }

  },
  methods: {
    handleSearch() {
      if (this.isTeamSearch) {
        this.teamSearchConfirm('yes');
        return;
      }
      this.teamSearchConfirm('no');
    },
    openTeamSearchConfirm() {
      // console.log('Opening team search confirmation dialog');
      this.teamSearchConfirmDialogVisible = true;
    },
    closeTeamSearchConfirm() {
      this.teamSearchConfirmDialogVisible = false;
    },
    async teamSearchConfirm(action) {
      this.selectedTeam = null;
      this.teamSearchConfirmDialogVisible = false;
      if (action === 'yes') {
        // Handle the case when the user confirms they are searching for a team
        await this.searchTeams();
        this.openSearchedTeamsDialog();
      } else if (action === 'no') {
        // Handle the case when the user denies they are searching for a team
        this.search();
      }
    },
    async searchTeams() {
      // if (!this.criteria || this.criteria.trim() === '') {
      //   this.$message.error('Please enter a team keyword to search.');
      //   return;
      // }

      this.$store.commit('loading', { loading: true, text: 'Searching for teams...' });

      const storedOrganisation = this.$store.getters['national/getOrganisation'];
      // console.log({
      //   criteria: this.criteria,
      //   organisation: storedOrganisation
      // });
      const filters = _.cloneDeep(this.filters);
      if (storedOrganisation?._id) {
        if (!filters.organisation) {
          filters.organisation = {};
        }
        filters.organisation._id = storedOrganisation._id;
        filters.organisation.level = _.capitalize(storedOrganisation.level);
        filters.isOrganisation = true;
        // this.personalise.organisationId = storedOrganisation._id;
        // if (this.filters.organisation.level !== 'national') {
        //   this.fixedOrganisation = true;
        // }
      }
      try {
        const res = await this.$http.post('/assemble/api/v1/portal/registrations/search-team', {
          criteria: this.criteria,
          filters
        });
        // console.log({
        //   searchRes: res.data.data
        // });
        this.searchedTeams = _.get(res, 'data.data.teams', []);
      } catch (error) {
        this.$message.error('Error searching for teams. Please try again later.');
        this.$store.commit('loading', false);
      } finally {
        this.$store.commit('loading', false);
      }
    },
    openSearchedTeamsDialog() {
      // console.log('Opening searched teams dialog');
      this.searchedTeamsDialogVisible = true;
    },
    closeSearchTeamsDialog() {
      this.searchedTeamsDialogVisible = false;
      this.searchedTeams = [];
    },
    handleSearchedTeamSelected(team) {
      // console.log('Selected team:', team);
      this.selectedTeam = team;
      this.searchedTeamsDialogVisible = false;
      // this.filters.teamId = team._id;
      // this.criteria = productId;
      this.search();
    },
    searchTeamName(team) {
      // if (team && product) {
      //   const teamName = team.meta?.find((m) => m.productId === product._id)?.name;
      //   return teamName || 'N/A';
      // }
      return team.name || 'N/A';
    },
    generateTagSignature(tags) {
      return tags && tags.length > 0
        ? tags.map((tag) => tag._id).sort().join(',')
        : '';
    },
    checkUpgradeEligible(rego) {
      const regoId = rego._id;
      const foundProducts = [];

      if (this.memberMembership && rego.product && rego.product.length > 0) {
        // Check each product in the registration's product array
        rego.product.forEach((regoProduct) => {
          this.memberMembership.forEach((membership) => {
            if (_.get(membership, 'regoEntity.products.upgradeableMembershipList') && !membership.expired) {
              membership.regoEntity.products.upgradeableMembershipList.forEach((um) => {
                if (um._id === regoId) {
                  const foundProduct = um.products.find((product) => product._id === regoProduct._id);
                  if (foundProduct) {
                    foundProducts.push(foundProduct);
                  }
                }
              });
            }
          });
        });
      }

      return !!foundProducts.length;
    },
    checkProductUpgradeEligible(regoId, productId) {
      if (this.memberMembership) {
        return this.memberMembership.some((membership) => {
          if (_.get(membership, 'regoEntity.products.upgradeableMembershipList') && !membership.expired) {
            return membership.regoEntity.products.upgradeableMembershipList.some((um) => {
              if (um._id === regoId) {
                return um.products.some((product) => product._id === productId);
              }
              return false;
            });
          }
          return false;
        });
      }
      return false;
    },
    getUpgradeableFromMemberships(rego) {
      const regoId = rego._id;
      const upgradeableFrom = [];

      if (this.memberMembership && rego.product && rego.product.length > 0) {
        // Check each product in the registration's product array
        rego.product.forEach((regoProduct) => {
          this.memberMembership.forEach((membership) => {
            if (_.get(membership, 'regoEntity.products.upgradeableMembershipList') && !membership.expired) {
              membership.regoEntity.products.upgradeableMembershipList.forEach((um) => {
                if (um._id === regoId) {
                  const foundProduct = um.products.find((product) => product._id === regoProduct._id);
                  if (foundProduct) {
                    upgradeableFrom.push({
                      membership,
                      targetProduct: foundProduct
                    });
                  }
                }
              });
            }
          });
        });
      }
      return upgradeableFrom;
    },
    getProductUpgradeableFromMemberships(rego, specificProduct) {
      const regoId = rego._id;
      const upgradeableFrom = [];

      if (this.memberMembership && specificProduct) {
        this.memberMembership.forEach((membership) => {
          if (_.get(membership, 'regoEntity.products.upgradeableMembershipList') && !membership.expired) {
            membership.regoEntity.products.upgradeableMembershipList.forEach((um) => {
              if (um._id === regoId) {
                const foundProduct = um.products.find((product) => product._id === specificProduct._id);
                if (foundProduct) {
                  upgradeableFrom.push({
                    membership,
                    targetProduct: foundProduct
                  });
                }
              }
            });
          }
        });
      }
      return upgradeableFrom;
    },
    openUpgradeDialog(upgradeData) {
      // Handle both registration-level and product-level upgrade clicks
      const rego = upgradeData.selectedProduct ? upgradeData : upgradeData;
      const { selectedProduct } = upgradeData;

      this.selectedUpgradeRego = rego;
      this.selectedUpgradeProduct = selectedProduct;

      if (selectedProduct) {
        // Product-specific upgrade - get upgrades for this specific product
        this.upgradeableFromMemberships = this.getProductUpgradeableFromMemberships(rego, selectedProduct);
      } else {
        // Registration-level upgrade - get upgrades for any product in the registration
        this.upgradeableFromMemberships = this.getUpgradeableFromMemberships(rego);
      }

      this.selectedSourceMembership = null;
      this.upgradeDialogVisible = true;
    },
    closeUpgradeDialog() {
      this.upgradeDialogVisible = false;
      this.selectedUpgradeRego = null;
      this.selectedUpgradeProduct = null;
      this.upgradeableFromMemberships = [];
      this.selectedSourceMembership = null;
      this.upgradeProcessing = false;
    },
    async processUpgrade() {
      if (!this.selectedSourceMembership || !this.selectedUpgradeRego) {
        this.$message.error('Please select a membership to upgrade from.');
        return;
      }

      this.upgradeProcessing = true;

      try {
        const regoId = this.selectedUpgradeRego._id;
        const productId = this.selectedUpgradeProduct ? this.selectedUpgradeProduct._id : this.selectedUpgradeRego.product[0]._id;

        // Start the direct upgrade process
        await this.startUpgradeProcess(regoId, productId);
      } catch (error) {
        this.$message.error('Failed to process upgrade. Please try again.');
        console.error('Upgrade error:', error);
        this.upgradeProcessing = false;
      }
    },
    calculateUpgradeSavings(sourceMembership, targetProduct) {
      if (sourceMembership && targetProduct) {
        const sourcePrice = _.get(sourceMembership, 'regoEntity.products.price', 0);
        const targetPrice = _.get(targetProduct, 'price', 0);
        const savings = Math.max(0, sourcePrice - targetPrice);
        return savings > 0 ? `$${(savings / 100).toFixed(2)}` : null;
      }
      return null;
    },
    formatMembershipName(membership) {
      return `${_.get(membership, 'regoEntity.name', 'Membership')} - ${_.get(membership, 'regoEntity.products.name', 'Product')}`;
    },

    async startUpgradeProcess(regoId, productId) {
      try {
        // Make the API call to get product details
        const response = await this.$http.post(`${process.env.VUE_APP_API_URL}/assemble/api/v1/portal/registrations/search/entities/${regoId}/products/${productId}`);
        const { result, transactionFee } = response.data.data;
        const [membershipToRegister] = result;

        if (membershipToRegister.productType === 'family') {
          // Handle family membership scenario
          this.handleFamilyUpgrade(membershipToRegister);
        } else {
          // Handle individual membership upgrade - navigate to registration flow
          this.handleIndividualUpgrade(membershipToRegister, transactionFee);
        }

        this.upgradeProcessing = false;
        this.closeUpgradeDialog();
      } catch (error) {
        console.error('Error in startUpgradeProcess:', error);
        throw error;
      }
    },
    handleIndividualUpgrade(membershipToRegister, transactionFee) {
      const registrations = this.$store.getters['cart/registrations'];
      const memberId = this.member?._id;
      const {
        _id: entityId, productType, memberType, ageFrom, ageTo
      } = membershipToRegister;

      // Check if registration already exists in cart
      const foundRego = registrations.find((r) => r.entityId === entityId
        && r.memberId === memberId
        && r.productType === productType
        && r.ageFrom === ageFrom
        && r.ageTo === ageTo
        && r.memberType === memberType);

      if (foundRego) {
        this.$message.error('Registration for this member has already been added to cart.');
        return;
      }

      // Set transaction fee and navigate to registration flow
      this.$store.commit('cart/setTransactionFee', transactionFee);

      const pathName = this.hasCustomEntity ? 'custom-membership-register-individual' : 'membership-register-individual';
      this.$router.push({
        name: pathName,
        params: {
          memberId,
          selectedMembership: membershipToRegister,
          upgradeFromMembership: this.selectedSourceMembership.membership
        },
      });
    },
    handleFamilyUpgrade(membershipToRegister) {
      // Family memberships require additional family member selection
      // Navigate to registration flow which handles family memberships
      const memberId = this.member?._id;
      const pathName = this.hasCustomEntity ? 'custom-membership-register-individual' : 'membership-register-individual';

      this.$router.push({
        name: pathName,
        params: {
          memberId,
          selectedMembership: membershipToRegister,
          upgradeFromMembership: this.selectedSourceMembership.membership
        },
      });
    },
    beforeFileUpload(file) {
      const isValidSize = file.size / 1024 / 1024 < 10;
      if (!isValidSize) {
        this.$message.error('File size must be less than 10MB');
        return false;
      }
      return true;
    },

    async handleFileChange(file) {
      if (!this.beforeFileUpload(file.raw)) return false;

      this.isUploading = true;
      try {
        // Get temporary upload URL
        const res = await this.$http.post(
          `${process.env.VUE_APP_API_URL}/assemble/api/v1/portal/files/tmp`,
          { fileName: file.name }
        );

        const { url, name, s3Path } = res.data;

        // Upload file to S3
        await fetch(url, {
          method: 'PUT',
          body: file.raw,
          headers: { 'Content-Type': '*/*' },
        });

        this.uploadedFile = {
          name,
          url: s3Path
        };

        this.fileList = [this.uploadedFile];
        this.$message.success('File uploaded successfully');
      } catch (error) {
        this.$message.error('Failed to upload file');
        console.error('Upload error:', error);
      } finally {
        this.isUploading = false;
      }
      return true;
    },
    selectRegoType(value) {
      this.personaliseRegoType = value;
    },
    selectMemberType(type) {
      this.personalise.memberType = type;
    },

    removeFile() {
      this.uploadedFile = null;
      this.fileList = [];
    },
    handleOpenBulkRego(value) {
      this.notFetching = value;
    },
    async applyForAccreditation(accreditation) {
      try {
        this.$store.commit('loading', { loading: true, text: 'Loading...' });
        const accreditationDataRes = await this.$http.get(`/assemble/api/v1/portal/accreditations/${accreditation._id}`);
        const accreditationData = accreditationDataRes.data.data;

        this.selectedAccreditation = accreditationData;

        if (accreditationData.additionalFields?.length > 0 || accreditationData.fileUploadRequired) {
          this.requireAccreditationAdditionalFields = true;
          this.additionalFieldsData = {}; // Reset form data
        } else {
          await this.submitAccreditationApplication();
        }
      } catch (error) {
        this.$message.error(error.response?.data?.message || 'Failed to load accreditation details');
      } finally {
        this.$store.commit('loading', false);
      }
    },
    async submitAccreditationApplication() {
      try {
        this.$store.commit('loading', { loading: true, text: 'Submitting application...' });

        const formData = {
          accreditationId: this.selectedAccreditation._id,
          memberId: this.memberId,
          additionalFields: this.additionalFieldsData
        };

        if (this.uploadedFile) {
          formData.fileUploads = [this.uploadedFile];
        }

        await this.$http.post('/assemble/api/v1/portal/accreditations/apply', formData);

        this.$message.success('Application submitted successfully');
        this.requireAccreditationAdditionalFields = false;
        this.requireAccreditationDialog = false;
      } catch (error) {
        this.$message.error(error.response?.data?.message || 'Failed to submit application');
      } finally {
        this.$store.commit('loading', false);
      }
    },
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },

    handleTagClose() {
      this.searchingRequiredMs = false;
      this.resetFilters();
      this.search();
    },
    onCartClick() {
      const pathName = this.hasCustomEntity ? 'custom-payment' : 'payment';
      if (this.cartCount > 0) this.$router.push({ name: pathName });
    },
    async searchByTag(tag) {
      this.filters.tags = [tag._id];
      // await this.search();
    },
    async joinWaitList(productId, eventId, entityType) {
      this.$store.commit('loading', { loading: true, text: 'Joining waitlist...' });
      this.$http.post('/assemble/api/v1/portal/waitlist', {
        eventId,
        entityId: eventId,
        type: entityType,
        memberId: this.memberId,
        productId
      }).then((res) => {
        this.$store.commit('loading', false);
        this.$message.success(res.data.message);
      }).catch((e) => {
        this.$store.commit('loading', false);
        this.$message.error(e.response.data.message);
      });
    },
    openDatePicker(nameRef) {
      this.$refs[nameRef].$refs.reference.$refs.input.setAttribute('readonly', 'readonly');
    },
    closeDatePicker(nameRef) {
      this.$refs[nameRef].$refs.reference.$refs.input.removeAttribute('readonly');
      this.personaliseSearch();
    },
    changeInputNumber(nameRef) {
      this.$refs[nameRef].$refs.input.setAttribute('type', 'tel');
      this.personaliseSearch();
    },
    togglePersonaliseCollapsible() {
      this.isPersonaliseCollapsibleOpen = !this.isPersonaliseCollapsibleOpen;
    },
    toggleFiltersCollapsible() {
      this.isFiltersCollapsibleOpen = !this.isFiltersCollapsibleOpen;
      // store the state of the filters collapsible
      this.$store.commit('finder/setFiltersCollapsibleOpen', this.isFiltersCollapsibleOpen);
    },
    selectMemberFromBoard(member) {
      this.memberId = member._id;
      this.member = member;
    },
    async search(event) {
      this.pageNumber = 1;
      this.isNoMore = false;
      this.$store.commit('loading', { loading: true, text: 'Searching...' });
      if (typeof this.criteria === 'string') {
        this.$store.commit('finder/setCriteria', this.criteria);
      }
      // check if product id is in the params, if not, set it to undefined
      if (this.productId) {
        this.filters.productId = this.productId;
      } else {
        this.filters.productId = undefined;
      }
      if (event && event.length > 0) {
        this.criteria = undefined;
        this.filters = {
          registrationTypes: undefined,
          memberTypes: undefined,
          tags: [],
          entityType: undefined,
          location: undefined,
          eventDateRange: [],
          organisation: {
            _id: undefined,
            level: undefined,
          },
          gender: undefined,
          ageFrom: 1,
          ageTo: 99,
        };
      }
      const storedOrganisation = this.$store.getters['national/getOrganisation'];
      if (storedOrganisation?._id) {
        this.filters.organisation._id = storedOrganisation._id;
        this.filters.organisation.level = _.capitalize(storedOrganisation.level);
        this.personalise.organisationId = storedOrganisation._id;
        if (this.filters.organisation.level !== 'national') {
          this.fixedOrganisation = true;
        }
      }

      let criteria = _.cloneDeep(this.criteria);
      if (this.isTeamSearch && this.selectedTeam && this.selectedTeam._id) {
        this.filters.teamId = this.selectedTeam._id;
        criteria = '';
      } else {
        this.filters.teamId = null;
      }

      // this.$store.commit('loadingText', 'Personalising your search...');
      const resSearch = await this.$http.post(`/assemble/api/v1/portal/registrations/new-search/${this.pageSize}/${this.pageNumber}`, {
        criteria: _.trim(criteria),
        filters: this.filters,
        membershipProductsRequired: event && event.length > 0 ? event : [],
        selectedTeam: this.isTeamSearch ? this.selectedTeam : null,
      });
      const { result, transactionFee, total } = resSearch.data.data;

      this.registrations = result;
      this.totalData = total;
      this.key++;
      this.$store.commit('cart/setTransactionFee', transactionFee);
      this.$store.commit('loading', false);
      this.selectedTeam = null;
    },
    debounceSearch: _.debounce(async function (query) {
      if (query && query.length < 3) return;
      await this.search();
    }, 500),
    async getMemberMembership(memberId) {
      const response = await this.$http.get(`/assemble/api/v1/portal/registrations/members/${memberId}`);
      return response;
    },
    async getTagGroups() {
      const response = await this.$http.get('/assemble/api/v1/portal/tags');
      let tagsData = response.data.data;
      tagsData = this.reducedTagsData(tagsData);
      this.tags = [...this.tags, ...tagsData];
    },
    reducedTagsData(tagsData) {
      return _.reduce(tagsData, (tags, tag) => {
        tags.push({ value: tag._id, label: tag.name });
        return _.orderBy(tags, ['label'], 'asc');
      }, []);
    },
    async loadMoreEvents() {
      if (this.loading
      || this.isNoMore
      // || this.selectedTeam
      ) return;

      this.loading = true;
      try {
        const hasMore = this.totalData > this.registrations.length;

        if (!hasMore) {
          this.isNoMore = true;
          this.loading = false;
          return;
        }

        this.pageNumber += 1;
        const resSearch = await this.$http.post(`/assemble/api/v1/portal/registrations/new-search/${this.pageSize}/${this.pageNumber}`, {
          criteria: _.trim(this.criteria),
          filters: this.filters,
          membershipProductsRequired: this.searchingRequiredMs && this.membershipRequiredProductsList && this.membershipRequiredProductsList.length > 0 ? this.membershipRequiredProductsList : [],
          selectedTeam: this.isTeamSearch ? this.selectedTeam : null,
        });

        const { result, transactionFee, total } = resSearch.data.data;
        this.totalData = total;
        const uniqueResults = result.filter((newItem) => !this.registrations.some((existingItem) => existingItem._id === newItem._id));
        this.registrations = this.registrations.concat(uniqueResults);

        // Check if we've loaded all available data
        this.isNoMore = this.registrations.length >= total;

        this.teamDetails = {};
        this.$store.commit('cart/setTransactionFee', transactionFee);

        // If we got less than 3 results and there's more data, trigger another load
        if (uniqueResults.length < 3 && !this.isNoMore) {
          this.loading = false;

          // await this.$nextTick();
          await this.loadMoreEvents();
        }
      } catch (error) {
        datadogRum.addError(error, {
          tags: { error: 'Error loading more events' },
        });
        this.$message.error('Failed to load more events');
      } finally {
        this.loading = false;
      }
    },
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
    handleScroll() {
      if (this.notFetching) return;
      const nearBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 100;

      if (nearBottom && !this.notFetching) {
        this.loadMoreEvents();
      }
    },
    async resetFilters() {
      this.pageNumber = 1;
      this.personaliseRegoType = undefined;
      this.filters = {
        registrationTypes: undefined,
        memberTypes: undefined,
        tags: [],
        entityType: undefined,
        location: undefined,
        eventDateRange: [],
        organisation: {
          _id: undefined,
          level: undefined,
        },
        gender: undefined,
        ageFrom: 1,
        ageTo: 99,
      };
      // reset personalise
      this.personalise = {
        regoType: undefined,
        memberType: undefined,
        location: undefined,
        eventDateRange: [undefined, undefined],
        organisationId: undefined,
        tags: [],
        regoOpen: 'open'
      };
      this.searchingRequiredMs = false;
      // call search
      await this.personaliseSearch();
    },
    updateField(fieldRef) {
      this.personalise[fieldRef] = this.$refs[fieldRef].value;
    },
    async personaliseSearch() {
      const {
        memberType, location, eventDateRange, organisationId, regoOpen
      } = this.personalise;

      const regoType = this.personaliseRegoType;
      this.filters.memberTypes = memberType;
      // unique member types
      // this.filters.memberTypes = _.uniq(this.filters.memberTypes);
      this.filters.location = location;
      this.filters.eventDateRange = eventDateRange;
      // find organisation level
      if (organisationId) {
        const organisation = this.organisations.find((group) => group.options.find((org) => org._id === organisationId));
        if (organisation) {
          _.assign(this.filters.organisation, {
            level: organisation.label,
            _id: organisationId,
          });
        }
      } else {
        this.filters.organisation = {
          _id: undefined,
          level: undefined,
        };
      }
      // const org = this.organisations.find((o) => o._id === organisationId);
      // this.filters.organisationId = organisationId;

      // this.filters.tags = tags;
      this.filters.regoOpen = regoOpen;
      if (regoType === 'event') {
        this.filters.registrationTypes = 'indv';
        this.filters.entityType = 'event';
      } else if (regoType === 'participate') {
        // this.filters.registrationTypes.push('indv');
        this.filters.registrationTypes = 'indv-to-team';
        this.filters.entityType = undefined;
      } else if (regoType === 'team') {
        this.filters.registrationTypes = 'team';
        this.filters.entityType = 'team';
      } else if (regoType === 'membership') {
        // this.filters.registrationTypes = 'indv';
        this.filters.entityType = 'membership';
      } else if (regoType === '') {
        // reset registration types
        this.filters.registrationTypes = undefined;
        this.filters.entityType = undefined;
      }
      // unique rego types
      // this.filters.registrationTypes = _.uniq(this.filters.registrationTypes);
      // store the filters/personalize back into the store
      this.$store.commit('finder/setFilters', this.filters);
      this.$store.commit('finder/setPersonalise', { ...this.personalise, regoType });

      await this.search();
    },
    async startRegistration(rego) {
      // Show mobile drawer on tablet and smaller devices, but only if drawer is not already open
      if (this.isTabletAndSmaller && !this.mobileDrawerVisible) {
        this.expandedRegistration = rego;
        this.mobileDrawerVisible = true;
        return;
      }

      this.selectedRego = rego;
      if (rego.productType === 'indv-to-team' && rego.teams && !rego.selectedTeam) { return this.$message.error('Select a team to register.'); }
      if (rego.productType === 'entity' && !rego.selectedEntity) {
        return this.$message.error('Select an entity level to register.');
      }
      if (this.selectedRego.productType === 'entity') {
        const pathName = this.hasCustomEntity ? 'custom-membership-register-entity' : 'membership-register-entity';
        this.$router.push({
          name: pathName,
          params: { criteria: this.criteria, selectedMembership: this.selectedRego },
        });
      } else if (rego.productType === 'family') {
        this.$store.commit('loading', false);
        const pathName = this.hasCustomEntity ? 'custom-membership-register-individual' : 'membership-register-individual';
        this.$router.push({
          name: pathName,
          params: { criteria: this.criteria, selectedMembership: this.selectedRego },
        });
      } else if (this.selectedRego.productType === 'team') {
        const pathName = this.hasCustomEntity ? 'custom-event-register-team' : 'event-register-team';
        this.$router.push({
          name: pathName,
          params: { criteria: this.criteria, selectedEvent: this.selectedRego },
        });
      } else if (this.memberId && _.get(this.member, 'profile.dob')) {
        // if user selected member in dashboard to register
        const { meta } = rego;
        const { ageAsOfDate, ageCalculationType } = meta || {};
        // eslint-disable-next-line no-nested-ternary
        const endOfYear = ageCalculationType === 'specific'
          ? ageAsOfDate
          // eslint-disable-next-line no-nested-ternary
          : ageCalculationType === 'registration'
            ? moment().format('YYYY-MM-DD')
            : ageCalculationType === 'default' && !ageAsOfDate
              ? this.$store.getters['national/endOfYear']
              : ageAsOfDate;
        const age = calculateMemberAge(this.member.profile.dob, endOfYear);
        // const validProduct = _.find(rego.products, (p) => age >= p.ageFrom && age <= p.ageTo && (p.gender === this.member.profile.gender || p.gender === 'All'));
        // check if member is eligible to register
        // check if age is in range
        const product = rego.products[0];
        const validAge = product.ageFrom <= age && product.ageTo >= age;
        if (!validAge) {
          return this.$message.error('Unfortunately the member you selected doesn\'t meet the Age range registration criteria');
        }
        const validGender = product.gender === this.member.profile.gender || product.gender === 'All' || (product.gender === 'Other' && (this.member.profile.gender !== 'Male' || this.member.profile.gender !== 'Female'));

        if (!validGender) {
          return this.$message.error('Unfortunately the member you selected doesn\'t meet the Gender registration criteria');
        }
        if (rego.products.find((p) => p.isMembershipRequired)) {
          console.log('membership required');
          // Check if this is a renewal scenario
          if (rego.renewFrom) {
            console.log('renewal scenario');
            this.$store.commit('loading', { loading: true, text: 'Validating renewal eligibility...' });

            return this.$http.post('/assemble/api/v1/portal/registrations/validate-renewal', {
              registrationId: rego.renewFrom,
              memberId: this.memberId
            })
              .then((response) => {
                const { data } = response.data;

                // If renewal is not allowed due to missing prerequisites
                if (data && !data.canRenew
                    && data.details && data.details.membershipProductsRequired?.length) {
                  const { membershipProductsRequired } = data.details;

                  this.$store.commit('loading', false);

                  // Show confirmation dialog
                  return this.$confirm('Membership is required to renew this registration. Do you want to register the required membership?', 'Membership Required', {
                    confirmButtonText: 'Get Membership',
                    cancelButtonText: 'No',
                    type: 'warning',
                  }).then(async () => {
                    // Log the action
                    datadogRum.addAction('showing_prerequisites', {
                      memberId: this.memberId,
                      regoId: rego.renewFrom,
                      missingMemberships: membershipProductsRequired.length
                    });

                    // Store the pending rego for later
                    this.$store.commit('cart/setPendingRequiredRego', rego);

                    // Set the required memberships to display
                    this.searchingRequiredMs = true;
                    this.$set(this, 'membershipRequiredProductsList', membershipProductsRequired);
                    await this.search(membershipProductsRequired);
                  }).catch((e) => {
                    console.log('error', e);
                    this.$message({
                      type: 'info',
                      message: 'Cancelled',
                    });
                  });
                }
                // Renewal validation passed, continue with the registration
                this.$store.commit('loading', false);
                return this.selectMember(this.memberId);
              })
              .catch((error) => {
                this.$store.commit('loading', false);
                const errorMessage = error.response?.data?.message || 'Unable to validate renewal eligibility.';
                this.$message.error(errorMessage);

                datadogRum.addError(error, {
                  message: 'Error validating membership renewal',
                  tags: { feature: 'membership-renewal' }
                });
                return false;
              });
          }

          const currMemberMembership = this.$store.getters['user/getActiveMemberRegos'];

          // Create sets of concatenated feature strings for efficient lookup
          const requiredFeatureStrings = new Set();
          const memberFeatureStrings = new Set();

          // Check if we need to validate against event start date
          const checkExpiryFromEvent = rego.meta?.checkExpiryFromEventStart === true;
          const eventStartDate = checkExpiryFromEvent ? moment(rego.startDate).valueOf() : null;

          // Build a map to track which requirements need event date checking
          const requirementExpiryRules = new Map();

          // Build required membership feature strings
          rego.products[0].membershipProductsRequired.forEach((pr) => {
            const tagSig = this.generateTagSignature(pr.products.tags);
            const featureString = pr.products._id
              ? `productId:${pr.products._id}|membershipId:${pr._id}`
              : `${pr._id}|${pr.products.type}|${pr.products.memberType}|${tagSig}`;
            requiredFeatureStrings.add(featureString);

            // Track if this requirement needs event date checking
            const needsEventDateCheck = checkExpiryFromEvent && eventStartDate;
            requirementExpiryRules.set(featureString, needsEventDateCheck ? eventStartDate : moment().valueOf());
          });

          // Build member membership feature strings and collect valid memberships
          const foundMemberships = [];
          currMemberMembership.forEach((m) => {
            // Early exit for already expired memberships - they can't be valid for ANY date
            if (m.expired === true || m.expiry < moment().valueOf()) {
              return;
            }

            // Create feature strings for both product ID and legacy comparison
            const memberTagSig = this.generateTagSignature(_.get(m, 'regoEntity.products.tags', []));
            const memberFeatureString = `${m.entityId}|${m.productType}|${m.memberType}|${memberTagSig}`;
            const productIdFeatureString = m.productId ? `productId:${m.productId}|membershipId:${m.entityId}` : null;

            // Check if this membership matches any required membership and meets expiry requirements
            let isValidForRequirement = false;

            if (requiredFeatureStrings.has(memberFeatureString)) {
              // Check if membership expiry meets the requirement's specific date
              const requiredExpiryDate = requirementExpiryRules.get(memberFeatureString);
              if (requiredExpiryDate && m.expiry >= requiredExpiryDate) {
                isValidForRequirement = true;
              }
            }

            if (productIdFeatureString && requiredFeatureStrings.has(productIdFeatureString)) {
              const requiredExpiryDate = requirementExpiryRules.get(productIdFeatureString);
              if (requiredExpiryDate && m.expiry >= requiredExpiryDate) {
                isValidForRequirement = true;
              }
            }

            if (isValidForRequirement) {
              memberFeatureStrings.add(memberFeatureString);
              if (productIdFeatureString) {
                memberFeatureStrings.add(productIdFeatureString);
              }
              foundMemberships.push(m);
            }
          });

          const pendingRegos = this.$store.getters['cart/registrations'];

          // Check pending registrations using feature strings
          const pendingFeatureStrings = new Set();
          pendingRegos.forEach((reg) => {
            if (reg.memberId === this.memberId) {
              const pendingTagSig = this.generateTagSignature(reg.product.tags);

              // Add legacy feature string
              const legacyFeatureString = `${reg.product._id}|${reg.product.type}|${reg.product.memberType}|${pendingTagSig}`;
              pendingFeatureStrings.add(legacyFeatureString);

              // Add productId feature string if entityId exists
              if (reg.product._id && reg.entityId) {
                const productIdFeatureString = `productId:${reg.product._id}|membershipId:${reg.entityId}`;
                pendingFeatureStrings.add(productIdFeatureString);
              }
            }
          });

          const requiredMembershipInPendingRegos = [...requiredFeatureStrings].some((required) => pendingFeatureStrings.has(required));

          // const membershipIds = _.uniq(_.map(rego.products[0].membershipProductsRequired, '_id'));
          // const productIds = _.uniq(_.map(rego.products[0].membershipProductsRequired, 'products._id'));
          if (!foundMemberships.length && !requiredMembershipInPendingRegos) {
            this.$confirm('Membership is required to join this event/membership. Do you want to register the required membership? ', 'Membership Required', {
              confirmButtonText: 'Get Membership',
              cancelButtonText: 'No',
              type: 'warning',
            }).then(async () => {
              this.$store.commit('cart/setPendingRequiredRego', rego);
              this.searchingRequiredMs = true;
              // close drawer
              this.closeDrawer();
              this.$set(this, 'membershipRequiredProductsList', rego.products[0].membershipProductsRequired);
              await this.search(rego.products[0].membershipProductsRequired);
            }).catch((e) => {
              console.log('error', e);
              this.$message({
                type: 'info',
                message: 'Cancelled',
              });
            });
            return false;
            // this.requireMembershipDialog = true;
            // return false;
          }
        }
        if (rego.products.find((p) => p.isAccreditationRequired)) {
          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          const accreditationIds = _.map(_.get(rego, 'products[0].accreditationProductsRequired', []), (a) => a._id);
          const outerThis = this;
          this.$http.post('/assemble/api/v1/portal/registrations/member-accreditations', { accreditationIds })
            .then((res) => {
              this.$store.commit('loading', false);
              const accredMemberIds = res.data.data;
              if (!_.includes(accredMemberIds, outerThis.memberId)) {
                outerThis.selectedRego = rego;
                outerThis.requireAccreditationDialog = true;
              } else {
                outerThis.selectMember(this.memberId);
              }
            }).catch((e) => {
              this.$message.error(e.response.data.message);
              this.$store.commit('loading', false);
            });
        } else {
          this.selectMember(this.memberId);
        }
      } else {
        this.selectMemberModalVisible = true;
      }
      return true;
    },
    closeDrawer() {
      this.viewingRego = null;
      this.mobileDrawerVisible = false;
      this.expandedRegistration = null;
      this.drawerExpandAll = false;
      this.key += 1;
    },
    getRegoLogo(rego) {
      const regoLogo = _.get(rego, 'meta.imgUrl', this.defaultRegoLogo);
      return `${regoLogo}?v=${moment().valueOf()}`;
    },
    async selectMember(memberId) {
      const currentSeason = this.$store.getters['national/currentSeason'];
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      // this.$store.commit('loadingText', 'Loading...');
      this.memberID = memberId;
      // Verify if eventId, memberId and memberType exists
      const registrations = this.$store.getters['cart/registrations'];

      if (this.selectedRego.registrationType === 'event') {
        const {
          productType, products
        } = this.selectedRego;

        const { _id: productId } = products[0];

        const foundRego = _.find(registrations, (r) => r.product?._id === productId && r.memberId === memberId);
        if (foundRego && productType !== 'indv-to-team') {
          this.$store.commit('loading', false);
          return this.$message.error('Registration for this member has already been added to cart.');
        }

        if (foundRego && productType === 'indv-to-team') {
          const currentTeamId = this.selectedRego.selectedTeam;
          const foundTeam = _.find(registrations, (t) => t.team && t.team._id === currentTeamId);
          if (foundTeam) {
            this.$store.commit('loading', false);
            return this.$message.error('Registration for this member has already been added to cart.');
          }
        }

        if (this.selectedRego.productType === 'indv') {
          this.$store.commit('loading', false);
          const pathName = this.hasCustomEntity ? 'custom-event-register-individual' : 'event-register-individual';
          this.$router.push({
            name: pathName,
            params: { criteria: this.criteria, memberId, selectedEvent: this.selectedRego },
          });
        } else if (this.selectedRego.productType === 'indv-to-team') {
          if (this.selectedRego.teams) {
            const team = this.selectedRego.teams.find((item) => item._id === this.selectedRego.selectedTeam);
            _.assign(this.selectedRego, { team });
            delete this.selectedRego.teams;
            delete this.selectedRego.selectedTeam;
          }
          this.$store.commit('loading', false);
          const pathName = this.hasCustomEntity ? 'custom-event-register-individual-to-team' : 'event-register-individual-to-team';
          this.$router.push({
            name: pathName,
            params: { criteria: this.criteria, memberId, selectedEvent: this.selectedRego },
          });
        } else {
          this.$store.commit('loading', false);
          this.$message.error('Registration for this product type is not available yet.');
        }
      } else if (this.selectedRego.registrationType === 'membership') {
        const { _id: productId } = this.selectedRego.products[0];

        const foundRego = _.find(registrations, (r) => r.product?._id === productId && r.memberId === memberId);
        if (foundRego) {
          this.$store.commit('loading', false);
          return this.$message.error('Registration for this member has already been added to cart.');
        }

        // check if member register to club membership before
        this.$store.commit('loading', { loading: true, text: 'Loading...' });
        // this.$store.commit('loadingText', 'Loading...');
        if (!this.currentMemberMemberships || this.currentMemberMemberships.length === 0) {
          const response = await this.getMemberMembership(memberId);
          this.memberMembership = response.data.data;
          this.$store.commit('user/setMemberRegos', this.memberMembership);
        }
        if (this.selectedRego.isClubMembership && this.selectedRego.memberType === 'player' && this.currentMemberMemberships.length) {
          const foundClubMembership = this.currentMemberMemberships.filter((rego) => {
            const regoSeason = +rego.season;
            if (rego.isClubMembership && regoSeason >= currentSeason - 2 && rego.memberType === 'player' && _.get(rego, 'orgtree.club._id') !== _.get(this.selectedRego, 'orgtree.club._id')) {
              return rego;
            }
            return false;
          });
          if (foundClubMembership.length) {
            const registeredMembership = foundClubMembership.find((club) => _.get(club, 'regoEntity.products._id') === _.get(this.selectedRego, 'products[0]._id')
            && club.entityId === this.selectedRego._id
            && club.memberId === memberId);
            if (registeredMembership) {
              this.$store.commit('loading', false);
              return this.$message.error('You have already registered to this club.');
            }
            await this.checkRequestClearances(memberId);
            this.$store.commit('loading', false);
          } else {
            const foundClubMembershipinCart = registrations.find((r) => r.isClubMembership);
            if (foundClubMembershipinCart) return this.$message.error('There is already a club membership in your cart, you can only buy one at a time .');
            this.$store.commit('loading', false);
            const pathName = this.hasCustomEntity ? 'custom-membership-register-individual' : 'membership-register-individual';
            this.$router.push({
              name: pathName,
              params: {
                criteria: this.criteria, memberId, member: this.member, selectedMembership: this.selectedRego
              },
            }).catch((error) => {
              if (
                error.name !== 'NavigationDuplicated'
                && !error.message.includes('Avoided redundant navigation to current location')
              ) {
                datadogRum.addError(error, {
                  message: 'Error navigating to membership register individual',
                  tags: { error: 'Error navigating to membership register individual' }
                });
              }
            });
          }
        } else {
          this.$store.commit('loading', false);
          const pathName = this.hasCustomEntity ? 'custom-membership-register-individual' : 'membership-register-individual';
          this.$router.push({
            name: pathName,
            params: {
              criteria: this.criteria, memberId, member: this.member, selectedMembership: this.selectedRego
            },
          }).catch((error) => {
            if (
              error.name !== 'NavigationDuplicated'
                && !error.message.includes('Avoided redundant navigation to current location')
            ) {
              datadogRum.addError(error, {
                message: 'Error navigating to membership register individual',
                tags: { error: 'Error navigating to membership register individual' }
              });
            }
          });
        }
      }
      return 0;
    },
    handleRequestClearances() {
      const { _id, entityId, memberType } = this.selectedRego;
      _.assign(this.clearanceRequest, {
        _id,
        entityId,
        memberId: this.memberID,
        memberType
      });
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.$http.post('/assemble/api/v1/portal/regoclearances', this.clearanceRequest)
        .then(() => {
          this.$store.commit('loading', false);
          this.$message.success('Request submitted successfully');
        })
        .catch((e) => {
          this.$message.error(e.response.data.message);
          this.$store.commit('loading', false);
        });
      this.clearanceDialogVisible = false;
      this.clearanceDeclinedDialogVisible = false;
    },
    async checkRequestClearances(memberId) {
      const { entityId } = this.selectedRego;
      const response = await this.$http.get(`/assemble/api/v1/portal/club/${entityId}/member/${memberId}/regoclearances`);
      const [result] = response.data.data;
      if (result) {
        this.memberClearanceRequest = result;
        if (this.memberClearanceRequest.status === 'Approved') {
          const pathName = this.hasCustomEntity ? 'custom-membership-register-individual' : 'membership-register-individual';
          this.$router.push({
            name: pathName,
            params: { criteria: this.criteria, memberId, selectedMembership: this.selectedRego },
          });
        }
        this.clearanceDialogVisible = true;
      } else {
        this.clearanceDialogVisible = true;
      }
    },
    async selectMembership(membership) {
      // fetch the membership details
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      // this.$store.commit('loadingText', 'Loading...');
      const resMemberhipRego = await this.$http.post(`/assemble/api/v1/portal/registrations/search/entities/${membership._id}/products/${membership.products._id}`);
      if (resMemberhipRego.data) {
        const { result } = resMemberhipRego.data.data;
        this.startRegistration(result[0]);
      }

      this.$store.commit('loading', false);
    },

    handleEventClicked(registrationId) {
      const findIndex = _.findIndex(this.registrations, (r) => r._id === registrationId);
      const registration = this.registrations[findIndex];

      if (this.viewingRego === registrationId) {
        this.viewingRego = null;
        // Close drawer on mobile if it was open
        if (this.innerWidth <= 1024) {
          this.mobileDrawerVisible = false;
          this.expandedRegistration = null;
        }
      } else {
        this.viewingRego = registrationId;
        // Open drawer on mobile
        if (this.innerWidth <= 1024) {
          this.expandedRegistration = registration;
          this.mobileDrawerVisible = true;
          this.drawerExpandAll = false;
          this.key += 1;
          return; // Don't scroll on mobile since we're opening drawer
        }
      }

      this.$nextTick(() => {
        const elementRef = `registration-main-${findIndex}`;
        const element = this.$refs[elementRef] && this.$refs[elementRef][0];

        if (element) {
          element.scrollIntoView({ behavior: 'auto' });
        } else {
          datadogRum.addError(new Error(`Element with ref ${elementRef} not found!`), {
            message: `Element with ref ${elementRef} not found!`,
            tags: { error: `Element with ref ${elementRef} not found!` }
          });
        }
      });
      this.key += 1;
    },
    async getMemberTypes() {
      const response = await this.$http.get('/assemble/api/v1/portal/nationals/member-types');
      const types = response.data.data.filter((memberType) => memberType.type !== 'legacy-membership');
      this.memberTypeTiles = types;
      this.memberTypes = types;
    },
    async getMemberList() {
      try {
        const response = await this.$http.get('/assemble/api/v1/account/portal/members-with-registrations');
        this.memberList = response.data.data;

        const activeMember = this.$store.getters['user/activeMember'];

        if (!this.memberId) {
          if (activeMember && activeMember._id) {
            // Prioritize the active member from the store
            this.memberId = activeMember._id;
          } else if (this.memberList.length > 0) {
            // Fall back to the first member in the list
            this.memberId = this.memberList[0]._id;

            // Optionally set the first member as active in the store
            this.$store.commit('user/setActiveMember', this.memberList[0]);
          }
        }
        if (this.memberId && !this.memberList.some((member) => member._id === this.memberId)) {
          this.memberId = this.memberList.length > 0 ? this.memberList[0]._id : null;
        }
      } catch (error) {
        datadogRum.addError(error, {
          message: 'Error fetching member list',
          tags: { error: 'Error fetching member list' }
        });
        this.$message.error('Failed to fetch member list. Please try again.');
      }
    },
    handleResize() {
      this.innerWidth = window.innerWidth;
    },
    async getOrganisations() {
      const stateResponsePromise = this.$http.get('/assemble/api/v1/portal/nationals/states');
      const assocResponsePromise = this.$http.get('/assemble/api/v1/portal/nationals/associations');
      const clubResponsePromise = this.$http.get('/assemble/api/v1/portal/nationals/clubs');
      const [stateResponse, assocResponse, clubResponse] = await Promise.all([stateResponsePromise, assocResponsePromise, clubResponsePromise]);
      this.organisations[0].options = stateResponse.data.data;
      this.organisations[1].options = assocResponse.data.data;
      this.organisations[2].options = clubResponse.data.data;
    },

    // Search Tour Methods
    startSearchTour() {
      this.showSearchTour = true;
    },

    restartSearchTour() {
      this.showSearchTour = true;
    },

    handleSearchTourCompleted() {
      this.showSearchTour = false;
      localStorage.setItem('search_tour_completed', 'true');
      this.$message.success('Great! You\'re ready to search for events.');
    },

    handleSearchTourSkipped() {
      this.showSearchTour = false;
      localStorage.setItem('search_tour_completed', 'true');
    },

    handleSearchTourClosed() {
      this.showSearchTour = false;
    }
  },
  filters: {
    cap(value) {
      if (!value) return '';
      // eslint-disable-next-line no-param-reassign
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  watch: {
    // eslint-disable-next-line func-names
    // 'personalise.eventDate': function (val) {
    // },

    '$refs.datepicker': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          const { input } = newVal.$refs;
          input.addEventListener('focus', this.openDatePicker);
        }
      },
    },
    // criteria: {
    //   immediate: true,
    //   handler(newVal) {

    //   },
    // },
  }
};
</script>

<style lang="scss" scoped>

::v-deep .el-drawer__header {
  margin-bottom: 0;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid #EBEEF5;
}
::v-deep .el-drawer__body {
  padding: 0;
}
.accreditation-dialog {
  ::v-deep .el-dialog__header {
    padding: 20px;
    border-bottom: 1px solid #EBEEF5;

    .el-dialog__title {
      font-size: 18px;
      font-weight: 600;
      color: #2c3e50;
    }

    .el-dialog__headerbtn {
      top: 15px;
    }
  }

  .dialog-content {
    padding: 20px;

    .dialog-description {
      margin-bottom: 24px;
      color: #606266;
      font-size: 14px;
    }
  }

  .form-item {
    margin-bottom: 20px;
  }

  .field-label {
    font-size: 14px;
    color: #606266;
    margin-bottom: 8px;
    font-weight: 500;
  }

  .custom-input {
    width: 100%;
    border: 1px solid #DCDFE6 !important;
    border-radius: 4px;

    .el-input__inner {
      border: 1px solid #DCDFE6 !important;
      border-radius: 4px;
      height: 40px !important;
      width: 100%;
      padding: 0 15px;
      font-size: 14px;
      color: #606266;

      &:focus {
        border-color: #002B5C !important;
      }

      &::placeholder {
        color: #C0C4CC;
      }
    }
  }

  ::v-deep .el-date-editor {
    width: 100%;

    .el-input__inner {
      border: 1px solid #DCDFE6 !important;
      border-radius: 4px;
      height: 40px !important;
      font-size: 14px;
      color: #606266;

      &:focus {
        border-color: #002B5C !important;
      }
    }

    .el-input__prefix {
      left: 8px;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 22px;

    .el-form-item__content {
      line-height: normal;
    }

    &.is-error {
      .el-input__inner {
        border-color: #F56C6C !important;
      }
    }
  }

  .upload-section {
    margin-top: 20px;
    text-align: center;
    padding: 20px;
    border: 1px dashed #DCDFE6;
    border-radius: 4px;
    background-color: #FAFAFA;

    .upload-button {
      background-color: #002B5C;
      border-color: #002B5C;
      width: 150px;
      height: 40px;
      font-size: 14px;

      &:hover, &:focus {
        background-color: #003875;
        border-color: #003875;
      }
    }

    .upload-description {
      margin-top: 8px;
      color: #606266;
      font-size: 12px;
    }
  }

  .dialog-footer {
    padding: 20px;
    text-align: right;
    border-top: 1px solid #EBEEF5;
    margin-top: 20px;

    .cancel-button {
      margin-right: 10px;
      padding: 9px 20px;
      font-size: 14px;
      border-radius: 4px;

      &:hover {
        color: #002B5C;
        border-color: #002B5C;
      }
    }

    .submit-button {
      background-color: #002B5C;
      border-color: #002B5C;
      padding: 9px 20px;
      font-size: 14px;
      border-radius: 4px;

      &:hover {
        background-color: #003875;
        border-color: #003875;
      }
    }
  }

  // Override Element UI's dialog styles
  ::v-deep.el-dialog {
    border-radius: 4px;
    overflow: hidden;

    .el-dialog__body {
      padding: 0;
    }
  }

  // Ensure all dialogs appear above the drawer
  ::v-deep .el-dialog__wrapper {
    z-index: 3000 !important;
  }

  // Ensure modal overlay appears above drawer but below dialog
  ::v-deep .v-modal {
    z-index: 2999 !important;
  }

  // Additional overrides for registration dialogs
  ::v-deep .el-dialog {
    z-index: 3001 !important;
  }

  // Ensure drawer has lower z-index
  ::v-deep .el-drawer {
    z-index: 1000 !important;
  }

  ::v-deep .el-drawer__wrapper {
    z-index: 1000 !important;
  }
}

.w-100 {
  width: 100%;
}

.accreditation-required-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-top: 2rem;
  width: 100%;
}
.accreditation-required {
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  padding: 1rem;
  border-bottom: 1px solid #c4c4c4;
}
.accreditation-type {
  background: rgba(196, 196, 196, 0.2);
  border-radius: 50px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 1.1rem;
  line-height: 2rem;
  width: 10rem;
}
.apply-button {
  width: 100%;
}
.accreditation-name {
  display: flex;
  align-items: center;
  padding-left: 1rem;
}

::v-deep .el-select{
  border: 1px solid #aaaaaa;
  width:100%;
  box-shadow: 0px 4px 4px rgba(233, 233, 233, 0.5);
  border-radius: 3px;
  height:2.8rem !important;

  .el-input {
    height: 100%;
    display: flex;

    .el-input__inner {
      border: none;
      height: 100%;
      flex: 1;
      padding: 0 15px;
      background: white;
      line-height: 1.5rem;
    }

    .el-input__suffix {
      width: 3rem;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-left: 1px solid #aaaaaa;
      background: white;
    }
  }

  .el-select__caret {
    color: #606266;
    transition: transform 0.3s;

    &.is-reverse {
      transform: rotateZ(180deg) !important;
    }
  }
}
::v-deep .el-form--label-top .el-form-item__label{
  padding:0
}

::v-deep .el-form-item__content{
  background: white;
  line-height: 1.5rem;
}

::v-deep .el-range-editor--small .el-range-input{
  background: none;
}

.reason{
  border: 1px solid #aaaaaa;
}
.finder-container{
  // calculate the height of the header and footer
  min-height: calc(100vh - 80px - 7em);
  position: relative;
  display: flex;
  overflow: visible; // Changed from auto to allow sticky positioning
  .personalise-search-productlist-container{
    width: 100%;
    flex-grow: 1;
    margin:0 auto;
    max-width: 992px;
    // overflow: auto;
    // max-height: 1500px;
    // overflow-y: auto;

    .member-board-small-screensize{
      // Enhanced mobile positioning with sticky behavior
      position: sticky;
      top: 50px; // Below navigation
      z-index: 100;
      background: white;
      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
      margin: 0 auto;
      width: 95%;
      max-width: 100%;
      overflow-x: hidden;

      @media only screen and (max-width: 576px) {
        margin: 0 auto;
        width: 100%;
        border-radius: 0; // Remove border radius on very small screens
      }
    }

    .personalise-container {
      // margin: 50px auto;
      max-width: 1268px;
      padding: 0 1rem;
      .personalise {
        margin-top: 20px;
        background: #f8f9fa;
        padding: 20px;
        border-radius: 8px;
        margin-bottom: 20px;

        .personalise-title {
          font-size: 18px;
          font-weight: 600;
          color: #2c3e50;
          margin-bottom: 16px;
          display: block;
        }
        .center-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 100%;
        }
        .register-button{
          background: var(--highlight-color, #5b7b97);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1rem;
          margin-top: 1rem;
          border: none;
          border-radius: 6px;
          padding: 10px 24px;
          font-weight: 600;
          transition: all 0.2s ease;

          &:hover {
            opacity: 0.9;
            transform: translateY(-1px);
          }
      }
        .remove-filter{
        color: var(--secondary-color);
        // display: flex;
        // align-items: center;
        // justify-content: center;
        font-size:1rem;
        margin-top:1rem;
        // add hover effect
        &:hover{
          cursor: pointer;
          text-decoration: underline;
        }
      }
        .filter-title {
          font-size: 18px;
          font-weight: 600;
          // color: var(--secondary-color);
          position: relative;
        }
        .date-picker{
          border: 1px solid #aaaaaa;
          width:100%;
          box-shadow: 0px 4px 4px rgba(233, 233, 233, 0.5);
          border-radius: 3px;
          height:39px !important;
          display: flex;
          align-items: center;
          justify-content: center;

        }
        .input-field{
          border: 1px solid #aaaaaa;
          border-radius: 3px;
          // width: 100%;
          display: flex !important;
          justify-content: flex-start;
          text-align: start;
        }
        .postcode{
          display: flex !important;
          margin: 0 !important;
        }
        .el-input-number {
          width: 100%;
        }
        .personalise-title {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 20px;
        }
        .filter-title {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 20px;
        }
      }
      .personalise-filters {
        margin-top: 24px;
        background: white;
        border-radius: 16px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        overflow: hidden;
        border: 1px solid rgba(0, 0, 0, 0.06);

        .personalise-title {
          font-size: 20px;
          font-weight: 600;
          color: #1e293b;
        }

        .center-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 100%;
        }

        .register-button{
          background: linear-gradient(135deg, #002B5C, #1e3a8a);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.3rem;
          margin-top: 1rem;
          border-radius: 12px;
          border: none;
          height: 44px;
          font-weight: 600;
          transition: all 0.2s ease;
          box-shadow: 0 4px 12px rgba(0, 43, 92, 0.25);

          &:hover, &:focus {
            background: linear-gradient(135deg, #1e3a8a, #1e40af);
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(0, 43, 92, 0.35);
          }
        }

        .remove-filter{
          color: #64748b;
          font-size: 1rem;
          margin-top: 1rem;
          font-weight: 500;
          transition: all 0.2s ease;

          &:hover{
            cursor: pointer;
            color: #374151;
            text-decoration: underline;
          }
        }

        // Enhanced header styling
        .d-flex.justify-content-between {
          padding: 20px 24px;
          background: linear-gradient(135deg, #f8fafc, #f1f5f9);
          border-bottom: 1px solid rgba(0, 0, 0, 0.04);
          margin: 0;

          .el-button {
            background: none;
            border: none;
            padding: 0;
            color: #334155;
            font-weight: 600;
            transition: all 0.2s ease;

            &:hover, &:focus {
              background: none;
              color: #002B5C;
              transform: translateY(-1px);
            }
          }

          .filter-count-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 22px;
            height: 22px;
            padding: 0 7px;
            margin-left: 8px;
            background: linear-gradient(135deg, #f56c6c, #e74c3c);
            color: white;
            border-radius: 12px;
            font-size: 13px;
            font-weight: 700;
            line-height: 1;
            box-shadow: 0 2px 8px rgba(245, 108, 108, 0.4);
            animation: pulse-badge 2s ease-in-out infinite;
          }

          @keyframes pulse-badge {
            0%, 100% {
              transform: scale(1);
              box-shadow: 0 2px 8px rgba(245, 108, 108, 0.4);
            }
            50% {
              transform: scale(1.1);
              box-shadow: 0 4px 12px rgba(245, 108, 108, 0.6);
            }
          }
        }

        .filter-title {
          font-size: 18px;
          font-weight: 600;
          color: #1e293b;
          margin: 0;
          margin-left: 8px;
        }
        .date-picker{
          border: 1px solid #aaaaaa;
          width:100%;
          box-shadow: 0px 4px 4px rgba(233, 233, 233, 0.5);
          border-radius: 3px;
          height:39px !important;
          display: flex;
          align-items: center;
          justify-content: center;

        }
        .input-field{
          border: 1px solid #aaaaaa;
          border-radius: 3px;
          // width: 100%;
          display: flex !important;
          justify-content: flex-start;
          text-align: start;
        }
        .postcode{
          display: flex !important;
          margin: 0 !important;
        }
        .el-input-number {
          width: 100%;
        }
        .personalise-title {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 20px;
        }
        .filter-title {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 20px;
        }
        .filter-layout{
          background: linear-gradient(135deg, #f8fafc, #f1f5f9);
          padding: 24px;
          margin: 0;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          grid-gap: 20px;

          .grid-span-2{
            grid-column: span 2;
          }

          @media screen and (max-width: 1200px) {
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            grid-gap: 16px;
            padding: 20px;
          }

          @media screen and (max-width: 768px) {
            grid-template-columns: 1fr 1fr;
            grid-gap: 12px;
            padding: 16px;
          }

          // Enhanced form styling to match event cards
          .el-form-item {
            margin-bottom: 0;

            .el-form-item__label {
              color: #374151;
              font-weight: 600;
              font-size: 14px;
              line-height: 1.4;
              margin-bottom: 8px;
              padding-bottom: 0;
            }

            .el-select {
              width: 100%;

              .el-input__inner {
                height: 44px;
                border: 1.5px solid #e2e8f0;
                border-radius: 12px;
                font-size: 14px;
                padding: 0 16px;
                background: white;
                transition: all 0.2s ease;

                &:hover {
                  border-color: #cbd5e1;
                }

                &:focus {
                  border-color: #002B5C;
                  box-shadow: 0 0 0 3px rgba(0, 43, 92, 0.1);
                }

                &.filter-selected {
                  border-color: #002B5C;
                  background: #f8fafc;
                }
              }

              .el-input__suffix {
                right: 12px;
              }
            }

            .el-input-number {
              width: 100%;

              .el-input__inner {
                height: 44px;
                border: 1.5px solid #e2e8f0;
                border-radius: 12px;
                font-size: 14px;
                padding: 0 16px;
                text-align: left;
                transition: all 0.2s ease;

                &:hover {
                  border-color: #cbd5e1;
                }

                &:focus {
                  border-color: #002B5C;
                  box-shadow: 0 0 0 3px rgba(0, 43, 92, 0.1);
                }

                &.filter-selected {
                  border-color: #002B5C;
                  background: #f8fafc;
                }
              }
            }

            .el-date-editor {
              width: 100%;

              .el-input__inner {
                height: 44px;
                border: 1.5px solid #e2e8f0;
                border-radius: 12px;
                font-size: 14px;
                padding-left: 40px;
                padding-right: 16px;
                transition: all 0.2s ease;

                &:hover {
                  border-color: #cbd5e1;
                }

                &:focus {
                  border-color: #002B5C;
                  box-shadow: 0 0 0 3px rgba(0, 43, 92, 0.1);
                }
              }

              .el-input__prefix {
                left: 12px;
                color: #64748b;
              }
            }
          }
        }

        // Enhanced button section
        .d-flex.bg-grey {
          background: linear-gradient(135deg, #f1f5f9, #e2e8f0) !important;
          padding: 20px 24px;
          margin: 0;
          border-top: 1px solid rgba(0, 0, 0, 0.04);

          .filter-button {
            background: var(--highlight-color, #5b7b97);
            border: none;
            border-radius: 8px;
            height: 40px;
            padding: 0 24px;
            font-weight: 600;
            font-size: 14px;
            color: white;
            letter-spacing: 0.025em;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            transition: all 0.2s ease;

            &:hover, &:focus {
              background: var(--highlight-color, #5b7b97);
              opacity: 0.9;
              transform: translateY(-1px);
              box-shadow: 0 6px 20px rgba(0, 43, 92, 0.35);
            }

            &:active {
              transform: translateY(0);
            }
          }

          .el-button--text {
            color: #64748b;
            font-weight: 500;
            padding: 0 16px;
            height: 44px;
            border-radius: 12px;
            transition: all 0.2s ease;

            &:hover, &:focus {
              color: #374151;
              background: rgba(100, 116, 139, 0.1);
            }
          }
        }

        // Mobile filters styling - only for tablet and smaller
        @media (max-width: 769px) {
          .mobile-filters-container {
            padding: 20px 16px;
            margin: 0;
            background: transparent;
          }

          .mobile-filters-section {
            background: #ffffff;
            border-radius: 12px;
            margin: 8px 0;
          }

          .mobile-filters-grid {
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            gap: 12px;
            justify-content: center;
            max-width: 100%;
            margin: 0 auto;
            padding: 0 8px;

            // Force items to wrap to new rows naturally
            .mobile-filter-item:nth-child(n+6) {
              grid-column: span 1;
            }

            .mobile-filter-item:nth-child(6) {
              grid-column-start: 1;
            }

            @media (max-width: 380px) {
              gap: 10px;
              padding: 0 6px;
            }

            @media (max-width: 320px) {
              gap: 8px;
              grid-template-columns: repeat(5, 1fr);
              padding: 0 4px;
            }
          }

          .mobile-filter-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            aspect-ratio: 1;
            min-width: 0;

            @media (max-width: 350px) {
              aspect-ratio: 1;
            }
            .mobile-popover-content {
            padding: 0;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
            border: 1px solid rgba(0, 0, 0, 0.06);
            background-color: #002B5C;

            .mobile-popover-header {
              display: flex;
              align-items: center;
              padding: 16px 20px;
              background: linear-gradient(135deg, #f8f9fa, #e9ecef);
              border-bottom: 1px solid rgba(0, 0, 0, 0.06);

              i {
                font-size: 18px;
                color: #409EFF;
                margin-right: 12px;
              }

              span {
                font-size: 16px;
                font-weight: 600;
                color: #2c3e50;
              }
            }

            .mobile-popover-body {
              padding: 20px;
              background: white;

              .popover-options {
                display: flex;
                flex-direction: column;
                gap: 12px;

                .popover-option {
                  display: flex;
                  align-items: center;
                  padding: 12px 16px;
                  border: 1px solid #e2e8f0;
                  border-radius: 8px;
                  cursor: pointer;
                  transition: all 0.2s ease;
                  background: #ffffff;
                  position: relative;

                  &:hover {
                    background: #f8f9fa;
                    border-color: #409EFF;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
                  }

                  &.selected {
                    background: linear-gradient(135deg, #409EFF, #5cb3f4);
                    border-color: #409EFF;
                    color: white;
                    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);

                    .option-check {
                      color: white;
                    }
                  }

                  .option-check {
                    margin-right: 12px;
                    font-size: 16px;
                    color: #409EFF;
                    font-weight: bold;
                  }

                  span {
                    font-size: 14px;
                    font-weight: 500;
                    flex: 1;
                    word-break: break-word;
                    overflow-wrap: break-word;
                  }
                }
              }

              .date-inputs {
                display: flex;
                flex-direction: column;
                gap: 12px;

                .el-date-picker {
                  width: 100%;
                }
              }

              .age-inputs {
                display: flex;
                gap: 12px;

                .el-input-number {
                  flex: 1;
                }
              }

              ::v-deep .el-select {
                width: 100%;
                border-radius: 8px;

                .el-input__inner {
                  border-radius: 8px;
                  border-color: #e2e8f0;
                  height: 40px;
                  line-height: 40px;

                  &:focus {
                    border-color: #409EFF;
                    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                  }
                }
              }

              ::v-deep .el-input-number {
                width: 100%;

                .el-input__inner {
                  border-radius: 8px;
                  border-color: #e2e8f0;
                  height: 40px;

                  &:focus {
                    border-color: #409EFF;
                    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                  }
                }
              }

              ::v-deep .el-date-editor {
                width: 100%;

                .el-input__inner {
                  border-radius: 8px;
                  border-color: #e2e8f0;
                  height: 40px;

                  &:focus {
                    border-color: #409EFF;
                    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                  }
                }
              }
            }

            .mobile-popover-actions {
              padding: 16px 20px;
              background: #f8f9fa;
              border-top: 1px solid rgba(0, 0, 0, 0.06);
              text-align: right;

              .el-button {
                background: linear-gradient(135deg, #409EFF, #5cb3f4);
                border: none;
                color: white;
                padding: 10px 24px;
                border-radius: 8px;
                font-weight: 500;
                transition: all 0.2s ease;

                &:hover {
                  background: linear-gradient(135deg, #337ecc, #4a9de8);
                  transform: translateY(-1px);
                  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
                }

                &:active {
                  transform: translateY(0);
                }
              }
            }
          }

          }

          .mobile-filter-icon {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 12px;
            background-color: #f8f9fa;
            border: 1px solid #e2e8f0;
            border-radius: 16px;
            cursor: pointer;
            transition: all 0.2s ease;
            width: 100%;
            height: 100%;
            text-align: center;
            position: relative;
            overflow: hidden;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

            @media (max-width: 350px) {
              padding: 10px 6px;
              min-height: 48px;
              border-radius: 14px;
            }

            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: linear-gradient(135deg, transparent, rgba(64, 158, 255, 0.03));
              opacity: 0;
              transition: opacity 0.2s ease;
            }

            &:hover {
              transform: translateY(-2px);
              background-color: #e9ecef;
              border-color: rgba(64, 158, 255, 0.3);
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            }

            &:active {
              transform: translateY(0);
              box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
            }

            &.has-selection {
              background: linear-gradient(135deg, #409EFF, #5cb3f4);
              border-color: #409EFF;
              color: white;

              i {
                color: white;
              }

              .selection-indicator {
                display: none;
              }
            }

            .icon-wrapper {
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
              height: 100%;
            }

            i {
              font-size: 20px;
              color: #6c757d;
              transition: all 0.2s ease;
              z-index: 1;

              @media (max-width: 350px) {
                font-size: 18px;
              }
            }

            .selection-indicator {
              position: absolute;
              top: 6px;
              right: 6px;
              width: 8px;
              height: 8px;
              background-color: #409EFF;
              border-radius: 50%;
              border: 2px solid white;
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
              z-index: 2;

              @media (max-width: 350px) {
                top: 4px;
                right: 4px;
                width: 6px;
                height: 6px;
              }
            }
          }

          // Mobile popover styles
          .mobile-popover-content {
            padding: 0;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
            border: 1px solid rgba(0, 0, 0, 0.06);
            background-color: #002B5C;

            .mobile-popover-header {
              display: flex;
              align-items: center;
              padding: 16px 20px;
              background: linear-gradient(135deg, #f8f9fa, #e9ecef);
              border-bottom: 1px solid rgba(0, 0, 0, 0.06);

              i {
                font-size: 18px;
                color: #409EFF;
                margin-right: 12px;
              }

              span {
                font-size: 16px;
                font-weight: 600;
                color: #2c3e50;
              }
            }

            .mobile-popover-body {
              padding: 20px;
              background: white;

              .popover-options {
                display: flex;
                flex-direction: column;
                gap: 12px;

                .popover-option {
                  display: flex;
                  align-items: center;
                  padding: 12px 16px;
                  border: 1px solid #e2e8f0;
                  border-radius: 8px;
                  cursor: pointer;
                  transition: all 0.2s ease;
                  background: #ffffff;
                  position: relative;

                  &:hover {
                    background: #f8f9fa;
                    border-color: #409EFF;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
                  }

                  &.selected {
                    background: linear-gradient(135deg, #409EFF, #5cb3f4);
                    border-color: #409EFF;
                    color: white;
                    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);

                    .option-check {
                      color: white;
                    }
                  }

                  .option-check {
                    margin-right: 12px;
                    font-size: 16px;
                    color: #409EFF;
                    font-weight: bold;
                  }

                  span {
                    font-size: 14px;
                    font-weight: 500;
                    flex: 1;
                    word-break: break-word;
                    overflow-wrap: break-word;
                  }
                }
              }

              .date-inputs {
                display: flex;
                flex-direction: column;
                gap: 12px;

                .el-date-picker {
                  width: 100%;
                }
              }

              .age-inputs {
                display: flex;
                gap: 12px;

                .el-input-number {
                  flex: 1;
                }
              }

              ::v-deep .el-select {
                width: 100%;
                border-radius: 8px;

                .el-input__inner {
                  border-radius: 8px;
                  border-color: #e2e8f0;
                  height: 40px;
                  line-height: 40px;

                  &:focus {
                    border-color: #409EFF;
                    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                  }
                }
              }

              ::v-deep .el-input-number {
                width: 100%;

                .el-input__inner {
                  border-radius: 8px;
                  border-color: #e2e8f0;
                  height: 40px;

                  &:focus {
                    border-color: #409EFF;
                    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                  }
                }
              }

              ::v-deep .el-date-editor {
                width: 100%;

                .el-input__inner {
                  border-radius: 8px;
                  border-color: #e2e8f0;
                  height: 40px;

                  &:focus {
                    border-color: #409EFF;
                    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                  }
                }
              }
            }

            .mobile-popover-actions {
              padding: 16px 20px;
              background: #f8f9fa;
              border-top: 1px solid rgba(0, 0, 0, 0.06);
              text-align: right;

              .el-button {
                background: linear-gradient(135deg, #409EFF, #5cb3f4);
                border: none;
                color: white;
                padding: 10px 24px;
                border-radius: 8px;
                font-weight: 500;
                transition: all 0.2s ease;

                &:hover {
                  background: linear-gradient(135deg, #337ecc, #4a9de8);
                  transform: translateY(-1px);
                  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
                }

                &:active {
                  transform: translateY(0);
                }
              }
            }
          }

        }

        // Override Element UI popover dropdown styles globally for mobile
        ::v-deep .el-select-dropdown {
          &.el-popper {
            z-index: 3000 !important;
            border: 1px solid #e2e8f0 !important;
            border-radius: 8px !important;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
            padding: 8px 0 !important;
            background: white !important;

            // Ensure mobile respects padding
            @media (max-width: 768px) {
              padding: 8px 0 !important;
              margin: 0 !important;
            }

            .el-select-dropdown__item {
              padding: 12px 16px !important;
              font-size: 14px !important;
              line-height: 1.4 !important;
              border-radius: 0 !important;
              transition: all 0.2s ease !important;
              margin: 0 !important;

              &:hover {
                background: #f8f9fa !important;
                color: #409EFF !important;
              }

              &.selected {
                background: #409EFF !important;
                color: white !important;
                font-weight: 500 !important;
              }

              // Ensure mobile devices respect padding/margin
              @media (max-width: 768px) {
                padding: 12px 16px !important;
                margin: 0 !important;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0.05);
              }
            }

            .el-scrollbar {
              .el-scrollbar__view {
                padding: 0 !important;
              }
            }
          }
        }

        // Override Element UI date picker dropdown
        ::v-deep .el-picker-panel {
          border-radius: 8px !important;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
          border: 1px solid #e2e8f0 !important;
          z-index: 3000 !important;
        }

        // Override Element UI popper positioning
        ::v-deep .el-popper {
          padding: 0 !important;
          z-index: 3000 !important;

          &[x-placement^="bottom"] {
            margin-top: 8px !important;
          }

          &[x-placement^="top"] {
            margin-bottom: 8px !important;
          }

          .popper__arrow {
            display: none !important;
          }
        }

      }
      .register-button{
        background: var(--secondary-color);

        color: var(--text-color-secondary);
        display: flex;
        align-items: center;
        justify-content: center;
        // width: 80%;
        font-size:1.3rem;
        margin-top:1rem;
      }
      .remove-filters{
        color: var(--secondary-color);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size:1rem;
        margin-top:1rem;
        // add hover effect
        &:hover{
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
    .search-container{
      // margin: 50px auto;
      max-width: 1268px;
      .search-box{
        margin: 20px 0;

        .search-wrapper {
          display: flex;
          gap: 12px;
          align-items: stretch;

          .search-input {
            flex: 1;

            ::v-deep .el-input__inner {
              height: 44px;
              border: 1px solid #e0e0e0;
              border-radius: 8px;
              padding: 0 16px;
              font-size: 15px;
              transition: border-color 0.2s;

              &:focus {
                border-color: var(--highlight-color, #5b7b97);
                outline: none;
              }
            }
          }

          .search-button {
            height: 44px;
            padding: 0 24px;
            background: var(--highlight-color, #5b7b97);
            border-color: var(--highlight-color, #5b7b97);
            border-radius: 8px;
            font-weight: 600;
            font-size: 14px;

            &:hover {
              opacity: 0.9;
            }
          }
        }
      }
    }

    // Mobile-specific search button styling
    &.mobile-view {
      .search-button {
        width: 44px;
        padding: 0;

        i {
          font-size: 18px;
        }
      }
    }
    .products-members-container{
      // display: grid;
      // grid-template-columns: 3fr 1fr;
      .registration-event-container{
        // display all the cards in a grid that is responsive to the screen size
        display: grid;
        list-style-type: none;
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        grid-gap: 20px;
        // max-width: 1268px;
        // margin: 20px auto 0;
        padding: 0 1rem;
        justify-content: center;
        grid-auto-flow: dense; /* [2] */
        .fullwidth{
          grid-column: 1 / -1 !important;
        }

      }
      .team-members-board{
        margin-top: 1rem;
        min-width: 300px;
      }
      .team-members-board-collapsible{
        display: none;
      }

    }
    @media screen and (max-width: 768px) {
      .products-members-container{
        display: flex;
        flex-direction: column-reverse;
        // .registration-event-container{
        //   max-width: 1000px;
        // }
        .team-members-board{
          display: none;
        }
        .team-members-board-collapsible{
          display: block;
        }
      }
      .search-container
      {
        max-width: 1000px;
      }
      .personalise-container{
        max-width: 1000px;
      }
    }
  }
  .team-members-board{
      margin-top: 1rem;
      min-width: 300px;
      position: fixed !important;
      top: 80px;
      right: 0;
      z-index: 1000;
    }

}

.desktop-view{
  // display: flex;
  // justify-content: space-between;
}
.mobile-view{
  display: flex;
  flex-direction: column-reverse;
  // justify-content: space-between;
}
.search-bar-team{
  border: 1px solid var(--secondary-color)y;
        border-radius: 3px;
        // width: 100%;
        display: flex !important;
        justify-content: flex-start;
        text-align: start;
        width: 100%;
        margin-top:1rem
}

.team-list{

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  // justify-content: center;
  margin-top: 2rem;
  width: 100%;
  height: 30rem;
  overflow-y: auto;
  padding: 10px;
  border-top: 1px solid #c4c4c4;
  border-bottom: 1px solid #c4c4c4;
  // padding: 1rem;
  .team{
    display: grid;
    grid-template-columns: 1fr 3fr 1fr;
    padding: 1rem;
    border-bottom: 1px solid #c4c4c4;
    .membership-type{
      background: rgba(196, 196, 196, 0.2);
      border-radius: 50px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 1.1rem;
      line-height: 2rem;
      width:10rem
    }
    .register-button{
      width: 100%;
    }
    .membership-name{
      display: flex;
    align-items: center;
    padding-left: 1rem;
    }
  }
}
.product-required-list{

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-top: 2rem;
  width: 100%;
  // padding: 1rem;
  .product-required{
    display: grid;
    grid-template-columns: 1fr 3fr 1fr;
    padding: 1rem;
    border-bottom: 1px solid #c4c4c4;
    .membership-type{
      background: rgba(196, 196, 196, 0.2);
      border-radius: 50px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 1.1rem;
      line-height: 2rem;
      width:10rem
    }
    .register-button{
      width: 100%;
    }
    .membership-name{
      display: flex;
    align-items: center;
    padding-left: 1rem;
    }
  }
}
::v-deep .el-dialog__body{
  flex-direction: column;
}
// ::v-deep .el-dialog{

//   width: 50% !important;
//   max-width: unset !important;
// }

// Mobile drawer header styles
.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  // add box-shadow to the bottom of the drawer-header
  min-height: 64px;

  .drawer-event-info {
    display: flex;
    align-items: center;
    flex: 1;

    .drawer-avatar {
      margin-right: 12px;

      .el-avatar {
        width: 42px;
        height: 42px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }
    }

    .drawer-details {
      flex: 1;

      .drawer-title {
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        margin: 0 0 2px 0;
        line-height: 1.4;
      }

      .drawer-subtitle {
        font-size: 13px;
        color: #666666;
        margin: 0;
        line-height: 1.3;
      }
    }
  }

  .drawer-actions {
    display: flex;
    align-items: center;

    .el-button {
      padding: 8px;
      min-width: auto;
      border: none;
      background: transparent;
      color: #999999;

      &:hover {
        background: rgba(0, 0, 0, 0.05);
        color: #333333;
      }

      i {
        font-size: 18px;
      }
    }
  }
}

// Search tour trigger styles
.search-tour-trigger {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;

  .restart-tour-button {
    background: white;
    border: 1px solid #ddd;
    border-radius: 20px;
    padding: 0.5rem 1rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      border-color: var(--highlight-color, #409eff);
      color: var(--highlight-color, #409eff);
    }

    i {
      margin-right: 0.5rem;
    }
  }
}

</style>
<style >
.custom-date-picker{
  background: yellow;
}

/* Upgrade Dialog Styling */
::v-deep .upgrade-dialog .el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

::v-deep .upgrade-dialog .el-dialog__header {
  background: linear-gradient(135deg, #67C23A, #85CE61);
  color: white;
  padding: 20px 24px;
}

::v-deep .upgrade-dialog .el-dialog__title {
  color: white;
  font-weight: 600;
  font-size: 18px;
}

.upgrade-dialog-content {
  padding: 24px;
}

.upgrade-header {
  margin-bottom: 24px;
}

.target-membership h3 {
  margin: 0 0 8px 0;
  color: #303133;
  font-size: 20px;
  font-weight: 600;
}

.target-description {
  margin: 0 0 12px 0;
  color: #606266;
  font-size: 14px;
}

.target-price {
  display: flex;
  align-items: center;
  gap: 8px;
}

.price-label {
  color: #909399;
  font-size: 14px;
}

.price-value {
  color: #67C23A;
  font-size: 18px;
  font-weight: 600;
}

.upgrade-options h4 {
  margin: 0 0 16px 0;
  color: #303133;
  font-size: 16px;
  font-weight: 600;
}

.membership-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.membership-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border: 2px solid #DCDFE6;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.membership-option:hover {
  border-color: #67C23A;
  background-color: #F0F9FF;
}

.membership-option.selected {
  border-color: #67C23A;
  background-color: #F0F9FF;
  box-shadow: 0 2px 8px rgba(103, 194, 58, 0.2);
}

.membership-info {
  flex: 1;
}

.membership-name {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 4px;
}

.membership-details {
  font-size: 14px;
  color: #909399;
}

.upgrade-benefit {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.savings {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #67C23A;
  font-size: 14px;
  font-weight: 600;
}

.upgrade-icon {
  color: #67C23A;
  font-size: 18px;
}

.no-upgrade-options {
  text-align: center;
  padding: 40px 0;
  color: #909399;
}

.upgrade-badge {
  cursor: pointer;
  transition: all 0.3s ease;
}

.upgrade-badge:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(103, 194, 58, 0.4) !important;
}

/* Upgrade filter checkbox styling */
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #67C23A;
  border-color: #67C23A;
}

::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #67C23A;
  font-weight: 600;
}

.search-checkbox {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.team-name-checkbox {
  margin-right: 4px;
}

/* .input-field-search {
  display: flex;
  align-items: center;
} */

.input-field-search .el-input__suffix {
  display: flex;
  align-items: center;
  justify-content: center;
}

.input-button-search {
  transform: translateY(3px);
  height: 34px;
}
.el-popover{
  padding: 0 !important;
  border-radius: 12px !important;
}
.mobile-popover-content {
            padding: 0;
            border-radius: 12px;
            overflow: hidden;

            .mobile-popover-header {
              display: flex;
              align-items: center;
              padding: 16px 20px;
              background: linear-gradient(135deg, #f8f9fa, #e9ecef);
              border-bottom: 1px solid rgba(0, 0, 0, 0.06);

              i {
                font-size: 18px;
                color: #409EFF;
                margin-right: 12px;
              }

              span {
                font-size: 16px;
                font-weight: 600;
                color: #2c3e50;
              }
            }

            .mobile-popover-body {
              padding: 20px;
              background: white;

              .popover-options {
                display: flex;
                flex-direction: column;
                gap: 12px;

                .popover-option {
                  display: flex;
                  align-items: center;
                  padding: 12px 16px;
                  border: 1px solid #e2e8f0;
                  border-radius: 8px;
                  cursor: pointer;
                  transition: all 0.2s ease;
                  background: #ffffff;
                  position: relative;

                  &:hover {
                    background: #f8f9fa;
                    border-color: #409EFF;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
                  }

                  &.selected {
                    background: linear-gradient(135deg, #409EFF, #5cb3f4);
                    border-color: #409EFF;
                    color: white;
                    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);

                    .option-check {
                      color: white;
                    }
                  }

                  .option-check {
                    margin-right: 12px;
                    font-size: 16px;
                    color: #409EFF;
                    font-weight: bold;
                  }

                  span {
                    font-size: 14px;
                    font-weight: 500;
                    flex: 1;
                    word-break: break-word;
                    overflow-wrap: break-word;
                  }
                }
              }

              .date-inputs {
                display: flex;
                flex-direction: column;
                gap: 12px;

                .el-date-picker {
                  width: 100%;
                }
              }

              .age-inputs {
                display: flex;
                gap: 12px;

                .el-input-number {
                  flex: 1;
                }
              }

              ::v-deep .el-select {
                width: 100%;
                border-radius: 8px;

                .el-input__inner {
                  border-radius: 8px;
                  border-color: #e2e8f0;
                  height: 40px;
                  line-height: 40px;

                  &:focus {
                    border-color: #409EFF;
                    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                  }
                }
              }

              ::v-deep .el-input-number {
                width: 100%;

                .el-input__inner {
                  border-radius: 8px;
                  border-color: #e2e8f0;
                  height: 40px;

                  &:focus {
                    border-color: #409EFF;
                    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                  }
                }
              }

              ::v-deep .el-date-editor {
                width: 100%;

                .el-input__inner {
                  border-radius: 8px;
                  border-color: #e2e8f0;
                  height: 40px;

                  &:focus {
                    border-color: #409EFF;
                    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                  }
                }
              }
            }

            .mobile-popover-actions {
              padding: 16px 20px;
              background: #f8f9fa;
              border-top: 1px solid rgba(0, 0, 0, 0.06);
              text-align: right;

              .el-button {
                background: linear-gradient(135deg, #409EFF, #5cb3f4);
                border: none;
                color: white;
                padding: 10px 24px;
                border-radius: 8px;
                font-weight: 500;
                transition: all 0.2s ease;

                &:hover {
                  background: linear-gradient(135deg, #337ecc, #4a9de8);
                  transform: translateY(-1px);
                  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
                }

                &:active {
                  transform: translateY(0);
                }
              }
            }
          }
          ::v-deep .el-popover{
            padding: 0 !important;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
            background-color: #002B5C;
          }
</style>
